import { assert } from './utility/Assert.js';
import './utility/WebGLPolyfill.js';
const webgl_capabilites_mock_zero = {
    MAX_TEXTURE_IMAGE_UNITS: 0,
    MAX_COMBINED_TEXTURE_IMAGE_UNITS: 0,
    MAX_VERTEX_TEXTURE_IMAGE_UNITS: 0,
    MAX_TEXTURE_SIZE: 0,
    MAX_SAMPLES: 0,
    MAX_CUBE_MAP_TEXTURE_SIZE: 0,
    MAX_RENDERBUFFER_SIZE: 0,
    MAX_VERTEX_ATTRIBS: 0,
    MAX_VARYING_VECTORS: 0,
    MAX_FRAGMENT_UNIFORM_VECTORS: 0,
    MAX_VERTEX_UNIFORM_VECTORS: 0,
    MAX_ARRAY_TEXTURE_LAYERS: 0,
    MAX_3D_TEXTURE_SIZE: 0,
    MAX_CLIENT_WAIT_TIMEOUT_WEBGL: 0,
    MAX_COLOR_ATTACHMENTS: 0,
    MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS: 0,
    MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS: 0,
    MAX_COMBINED_UNIFORM_BLOCKS: 0,
    MAX_DRAW_BUFFERS: 0,
    MAX_ELEMENT_INDEX: 0,
    MAX_ELEMENTS_INDICES: 0,
    MAX_ELEMENTS_VERTICES: 0,
    MAX_FRAGMENT_INPUT_COMPONENTS: 0,
    MAX_FRAGMENT_UNIFORM_BLOCKS: 0,
    MAX_FRAGMENT_UNIFORM_COMPONENTS: 0,
    MAX_PROGRAM_TEXEL_OFFSET: 0,
    MAX_SERVER_WAIT_TIMEOUT: 0,
    MAX_TEXTURE_LOD_BIAS: 0,
    MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS: 0,
    MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS: 0,
    MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS: 0,
    MAX_UNIFORM_BLOCK_SIZE: 0,
    MAX_UNIFORM_BUFFER_BINDINGS: 0,
    MAX_VARYING_COMPONENTS: 0,
    MAX_VERTEX_OUTPUT_COMPONENTS: 0,
    MAX_VERTEX_UNIFORM_BLOCKS: 0,
    MAX_VERTEX_UNIFORM_COMPONENTS: 0,
    MIN_PROGRAM_TEXEL_OFFSET: 0,
    UNIFORM_BUFFER_OFFSET_ALIGNMENT: 0,
    VERSION: '',
    VENDOR: '',
    RENDERER: '',
    IMPLEMENTATION_COLOR_READ_FORMAT: 0,
    IMPLEMENTATION_COLOR_READ_TYPE: 0,
    ALIASED_LINE_WIDTH_RANGE: new Float32Array([0, 0]), // size = 2
    ALIASED_POINT_SIZE_RANGE: new Float32Array([0, 0]), // size = 2
    RED_BITS: 0,
    GREEN_BITS: 0,
    BLUE_BITS: 0,
    ALPHA_BITS: 0,
    DEPTH_BITS: 0,
    STENCIL_BITS: 0,
    MAX_VIEWPORT_DIMS: new Int32Array([0, 0]), // size = 2
    SHADING_LANGUAGE_VERSION: '',
    SUBPIXEL_BITS: 0
};
export function get_current_capability_parameters(gl) {
    const caps = Object.assign({}, webgl_capabilites_mock_zero);
    for (const k in caps) {
        const v = gl.getParameter(gl[k]);
        if (typeof v !== typeof caps[k]) {
            console.error('Error! Mismatching types: ' + k);
        }
        caps[k] = v;
    }
    return caps;
}
export const webgl2_capabilities_mac_m2_chrome = {
    MAX_TEXTURE_IMAGE_UNITS: 16,
    MAX_COMBINED_TEXTURE_IMAGE_UNITS: 32,
    MAX_VERTEX_TEXTURE_IMAGE_UNITS: 16,
    MAX_TEXTURE_SIZE: 16384,
    MAX_SAMPLES: 4,
    MAX_CUBE_MAP_TEXTURE_SIZE: 16384,
    MAX_RENDERBUFFER_SIZE: 16384,
    MAX_VERTEX_ATTRIBS: 16,
    MAX_VARYING_VECTORS: 30,
    MAX_FRAGMENT_UNIFORM_VECTORS: 1024,
    MAX_VERTEX_UNIFORM_VECTORS: 1024,
    MAX_ARRAY_TEXTURE_LAYERS: 2048,
    MAX_3D_TEXTURE_SIZE: 2048,
    MAX_CLIENT_WAIT_TIMEOUT_WEBGL: 0,
    MAX_COLOR_ATTACHMENTS: 8,
    MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS: 53248,
    MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS: 53248,
    MAX_COMBINED_UNIFORM_BLOCKS: 24,
    MAX_DRAW_BUFFERS: 8,
    MAX_ELEMENT_INDEX: 4294967294,
    MAX_ELEMENTS_INDICES: 2147483647,
    MAX_ELEMENTS_VERTICES: 2147483647,
    MAX_FRAGMENT_INPUT_COMPONENTS: 120,
    MAX_FRAGMENT_UNIFORM_BLOCKS: 12,
    MAX_FRAGMENT_UNIFORM_COMPONENTS: 4096,
    MAX_PROGRAM_TEXEL_OFFSET: 7,
    MAX_SERVER_WAIT_TIMEOUT: 0,
    MAX_TEXTURE_LOD_BIAS: 15,
    MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS: 128,
    MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS: 4,
    MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS: 4,
    MAX_UNIFORM_BLOCK_SIZE: 16384,
    MAX_UNIFORM_BUFFER_BINDINGS: 24,
    MAX_VARYING_COMPONENTS: 120,
    MAX_VERTEX_OUTPUT_COMPONENTS: 120,
    MAX_VERTEX_UNIFORM_BLOCKS: 12,
    MAX_VERTEX_UNIFORM_COMPONENTS: 4096,
    MIN_PROGRAM_TEXEL_OFFSET: -8,
    UNIFORM_BUFFER_OFFSET_ALIGNMENT: 16,
    VERSION: 'WebGL 2.0 (OpenGL ES 3.0 Chromium)',
    VENDOR: 'WebKit',
    RENDERER: 'WebKit WebGL',
    IMPLEMENTATION_COLOR_READ_FORMAT: 6408,
    IMPLEMENTATION_COLOR_READ_TYPE: 5121,
    ALIASED_LINE_WIDTH_RANGE: new Float32Array([1, 1]),
    ALIASED_POINT_SIZE_RANGE: new Float32Array([1, 511]),
    RED_BITS: 8,
    GREEN_BITS: 8,
    BLUE_BITS: 8,
    ALPHA_BITS: 8,
    DEPTH_BITS: 24,
    STENCIL_BITS: 0,
    MAX_VIEWPORT_DIMS: new Int32Array([16384, 16384]),
    SHADING_LANGUAGE_VERSION: 'WebGL GLSL ES 3.00 (OpenGL ES GLSL ES 3.0 Chromium)',
    SUBPIXEL_BITS: 4
};
const webgl_state_mock_zero = {
    ACTIVE_TEXTURE: 0,
    ARRAY_BUFFER_BINDING: null,
    BLEND: false,
    BLEND_COLOR: new Float32Array([0, 0, 0, 0]), // size = 4
    BLEND_DST_ALPHA: 0,
    BLEND_DST_RGB: 0,
    BLEND_EQUATION: 0,
    BLEND_EQUATION_ALPHA: 0,
    BLEND_EQUATION_RGB: 0,
    BLEND_SRC_ALPHA: 0,
    BLEND_SRC_RGB: 0,
    COLOR_CLEAR_VALUE: new Float32Array([0, 0, 0, 0]), // size = 4
    COLOR_WRITEMASK: [false, false, false, false], // size = 4
    CULL_FACE: false,
    CULL_FACE_MODE: 0,
    CURRENT_PROGRAM: null,
    DEPTH_CLEAR_VALUE: 0,
    DEPTH_FUNC: 0,
    DEPTH_RANGE: new Float32Array([0, 0]), // size = 2
    DEPTH_TEST: false,
    DEPTH_WRITEMASK: false,
    DITHER: false,
    ELEMENT_ARRAY_BUFFER_BINDING: null,
    FRAMEBUFFER_BINDING: null,
    FRONT_FACE: 0,
    GENERATE_MIPMAP_HINT: 0,
    LINE_WIDTH: 0,
    PACK_ALIGNMENT: 0,
    POLYGON_OFFSET_FACTOR: 0,
    POLYGON_OFFSET_FILL: false,
    POLYGON_OFFSET_UNITS: 0,
    RENDERBUFFER_BINDING: null,
    SAMPLE_BUFFERS: 0,
    SAMPLE_COVERAGE_INVERT: false,
    SAMPLE_COVERAGE_VALUE: 0,
    SAMPLES: 0,
    SCISSOR_BOX: new Int32Array([0, 0, 0, 0]), // size = 4
    SCISSOR_TEST: false,
    STENCIL_BACK_FAIL: 0,
    STENCIL_BACK_FUNC: 0,
    STENCIL_BACK_PASS_DEPTH_FAIL: 0,
    STENCIL_BACK_PASS_DEPTH_PASS: 0,
    STENCIL_BACK_REF: 0,
    STENCIL_BACK_VALUE_MASK: 0,
    STENCIL_BACK_WRITEMASK: 0,
    STENCIL_CLEAR_VALUE: 0,
    STENCIL_FAIL: 0,
    STENCIL_FUNC: 0,
    STENCIL_PASS_DEPTH_FAIL: 0,
    STENCIL_PASS_DEPTH_PASS: 0,
    STENCIL_REF: 0,
    STENCIL_TEST: false,
    STENCIL_VALUE_MASK: 0,
    STENCIL_WRITEMASK: 0,
    TEXTURE_BINDING_2D: null,
    TEXTURE_BINDING_CUBE_MAP: null,
    UNPACK_ALIGNMENT: 0,
    UNPACK_COLORSPACE_CONVERSION_WEBGL: 0,
    UNPACK_FLIP_Y_WEBGL: false,
    UNPACK_PREMULTIPLY_ALPHA_WEBGL: false,
    VIEWPORT: new Int32Array([0, 0, 0, 0]), // size = 4
    // WebGL2
    COPY_READ_BUFFER_BINDING: null,
    COPY_WRITE_BUFFER_BINDING: null,
    DRAW_BUFFER0: 0,
    DRAW_BUFFER1: 0,
    DRAW_BUFFER2: 0,
    DRAW_BUFFER3: 0,
    DRAW_BUFFER4: 0,
    DRAW_BUFFER5: 0,
    DRAW_BUFFER6: 0,
    DRAW_BUFFER7: 0,
    DRAW_BUFFER8: 0,
    DRAW_BUFFER9: 0,
    DRAW_BUFFER10: 0,
    DRAW_BUFFER11: 0,
    DRAW_BUFFER12: 0,
    DRAW_BUFFER13: 0,
    DRAW_BUFFER14: 0,
    DRAW_BUFFER15: 0,
    DRAW_FRAMEBUFFER_BINDING: null,
    FRAGMENT_SHADER_DERIVATIVE_HINT: 0,
    PACK_ROW_LENGTH: 0,
    PACK_SKIP_PIXELS: 0,
    PACK_SKIP_ROWS: 0,
    PIXEL_PACK_BUFFER_BINDING: null,
    PIXEL_UNPACK_BUFFER_BINDING: null,
    RASTERIZER_DISCARD: false,
    READ_BUFFER: 0,
    READ_FRAMEBUFFER_BINDING: null,
    SAMPLE_ALPHA_TO_COVERAGE: false,
    SAMPLE_COVERAGE: false,
    SAMPLER_BINDING: null,
    TEXTURE_BINDING_2D_ARRAY: null,
    TEXTURE_BINDING_3D: null,
    TRANSFORM_FEEDBACK_ACTIVE: false,
    TRANSFORM_FEEDBACK_BINDING: null,
    TRANSFORM_FEEDBACK_BUFFER_BINDING: null,
    TRANSFORM_FEEDBACK_PAUSED: false,
    UNIFORM_BUFFER_BINDING: null,
    UNIFORM_BUFFER_OFFSET_ALIGNMENT: 0,
    UNPACK_IMAGE_HEIGHT: 0,
    UNPACK_ROW_LENGTH: 0,
    UNPACK_SKIP_IMAGES: 0,
    UNPACK_SKIP_PIXELS: 0,
    UNPACK_SKIP_ROWS: 0,
    VERTEX_ARRAY_BINDING: null
};
export function get_current_context_state(gl) {
    const state = Object.assign({}, webgl_state_mock_zero);
    for (const k in state) {
        const v = gl.getParameter(gl[k]);
        if (typeof v !== typeof state[k]) {
            console.error('Error! Mismatching types: ' + k + '\n\tGiven: ' + v + '(' + (typeof v) + ')' + '\n\tExpecting: ' + typeof state[k]);
        }
        state[k] = v;
    }
    return state;
}
export function create_default_context_state(caps, viewport) {
    const state = {
        ACTIVE_TEXTURE: 33984,
        ARRAY_BUFFER_BINDING: null,
        BLEND: false,
        BLEND_COLOR: new Float32Array([0, 0, 0, 0]),
        BLEND_DST_ALPHA: 0,
        BLEND_DST_RGB: 0,
        BLEND_EQUATION: 32774,
        BLEND_EQUATION_ALPHA: 32774,
        BLEND_EQUATION_RGB: 32774,
        BLEND_SRC_ALPHA: 1,
        BLEND_SRC_RGB: 1,
        COLOR_CLEAR_VALUE: new Float32Array([0, 0, 0, 0]),
        COLOR_WRITEMASK: [
            true,
            true,
            true,
            true
        ],
        CULL_FACE: false,
        CULL_FACE_MODE: 1029,
        CURRENT_PROGRAM: null,
        DEPTH_CLEAR_VALUE: 1,
        DEPTH_FUNC: 513,
        DEPTH_RANGE: new Float32Array([0, 1]),
        DEPTH_TEST: false,
        DEPTH_WRITEMASK: true,
        DITHER: true,
        ELEMENT_ARRAY_BUFFER_BINDING: null,
        FRAMEBUFFER_BINDING: null,
        FRONT_FACE: 2305,
        GENERATE_MIPMAP_HINT: 4352,
        LINE_WIDTH: 1,
        PACK_ALIGNMENT: 4,
        POLYGON_OFFSET_FACTOR: 0,
        POLYGON_OFFSET_FILL: false,
        POLYGON_OFFSET_UNITS: 0,
        RENDERBUFFER_BINDING: null,
        SAMPLE_BUFFERS: 1,
        SAMPLE_COVERAGE_INVERT: false,
        SAMPLE_COVERAGE_VALUE: 1,
        SAMPLES: 4,
        SCISSOR_BOX: new Int32Array([viewport.x, viewport.y, viewport.width, viewport.height]),
        SCISSOR_TEST: false,
        STENCIL_BACK_FAIL: 7680,
        STENCIL_BACK_FUNC: 519,
        STENCIL_BACK_PASS_DEPTH_FAIL: 7680,
        STENCIL_BACK_PASS_DEPTH_PASS: 7680,
        STENCIL_BACK_REF: 0,
        STENCIL_BACK_VALUE_MASK: 2147483647,
        STENCIL_BACK_WRITEMASK: 2147483647,
        STENCIL_CLEAR_VALUE: 0,
        STENCIL_FAIL: 7680,
        STENCIL_FUNC: 519,
        STENCIL_PASS_DEPTH_FAIL: 7680,
        STENCIL_PASS_DEPTH_PASS: 7680,
        STENCIL_REF: 0,
        STENCIL_TEST: false,
        STENCIL_VALUE_MASK: 2147483647,
        STENCIL_WRITEMASK: 2147483647,
        TEXTURE_BINDING_2D: null,
        TEXTURE_BINDING_CUBE_MAP: null,
        UNPACK_ALIGNMENT: 4,
        UNPACK_COLORSPACE_CONVERSION_WEBGL: 37444,
        UNPACK_FLIP_Y_WEBGL: false,
        UNPACK_PREMULTIPLY_ALPHA_WEBGL: false,
        VIEWPORT: new Int32Array([viewport.x, viewport.y, viewport.width, viewport.height]),
        COPY_READ_BUFFER_BINDING: null,
        COPY_WRITE_BUFFER_BINDING: null,
        DRAW_BUFFER0: 1029,
        DRAW_BUFFER1: 1029,
        DRAW_BUFFER2: 1029,
        DRAW_BUFFER3: 1029,
        DRAW_BUFFER4: 1029,
        DRAW_BUFFER5: 1029,
        DRAW_BUFFER6: 1029,
        DRAW_BUFFER7: 1029,
        DRAW_BUFFER8: 1029,
        DRAW_BUFFER9: 1029,
        DRAW_BUFFER10: 1029,
        DRAW_BUFFER11: 1029,
        DRAW_BUFFER12: 1029,
        DRAW_BUFFER13: 1029,
        DRAW_BUFFER14: 1029,
        DRAW_BUFFER15: 1029,
        DRAW_FRAMEBUFFER_BINDING: null,
        FRAGMENT_SHADER_DERIVATIVE_HINT: 4352,
        PACK_ROW_LENGTH: 0,
        PACK_SKIP_PIXELS: 0,
        PACK_SKIP_ROWS: 0,
        PIXEL_PACK_BUFFER_BINDING: null,
        PIXEL_UNPACK_BUFFER_BINDING: null,
        RASTERIZER_DISCARD: false,
        READ_BUFFER: 1029,
        READ_FRAMEBUFFER_BINDING: null,
        SAMPLE_ALPHA_TO_COVERAGE: false,
        SAMPLE_COVERAGE: false,
        SAMPLER_BINDING: null,
        TEXTURE_BINDING_2D_ARRAY: null,
        TEXTURE_BINDING_3D: null,
        TRANSFORM_FEEDBACK_ACTIVE: false,
        TRANSFORM_FEEDBACK_BINDING: null,
        TRANSFORM_FEEDBACK_BUFFER_BINDING: null,
        TRANSFORM_FEEDBACK_PAUSED: false,
        UNIFORM_BUFFER_BINDING: null,
        UNIFORM_BUFFER_OFFSET_ALIGNMENT: 16,
        UNPACK_IMAGE_HEIGHT: 0,
        UNPACK_ROW_LENGTH: 0,
        UNPACK_SKIP_IMAGES: 0,
        UNPACK_SKIP_PIXELS: 0,
        UNPACK_SKIP_ROWS: 0,
        VERTEX_ARRAY_BINDING: null
    };
    // Fields of DRAW_BUFFFERi are capabilities-dependent
    for (let i = caps.MAX_DRAW_BUFFERS; i < 16; i++) {
        const field = 'DRAW_BUFFER' + i.toString();
        state[field] = null;
    }
    return state;
}
/**
 * This class is meant to mock WebGL2.
 * It can optionally forward the calls to an actual WebGL2 context by assigning the 'passthrough' member, to make sure the implementation works as it should.
 * Use case is for testing, where we don't have a drawing surface and thus can't create a real WebGL2 context.
 *
 * Future: Add verification/testing that the state is correct:
 *    - Textures:
 *        - createTexture
 *        - deleteTexture
 *        - bindTexture
 *        - upload functions
 *        - get functions
 *    - Buffers:
 *        - createBuffer
 *        - deleteBuffer
 *        - bufferData
 *        - bufferSubData
 *    - Framebuffers:
 *        - createFramebuffer
 *        - deleteFramebuffer
 *        - checkFramebufferStatus
 *        - bindFramebuffer
 *        - attachment functions
 *    - Renderbuffers:
 *        - createRenderbuffer
 *        - deleteRenderbuffer
 *        - bindRenderbuffer
 *        - attachment functions
 */
export class WebGL2Mock {
    create_state_reverse_lookup_map() {
        const map = new Map();
        for (const k in this.state) {
            if (k in this) {
                if (typeof (this[k]) !== 'number') {
                    console.error('Incorrect type for enum for state field: ' + k);
                }
                else {
                    map.set(this[k], k);
                }
            }
            else {
                console.error('Missing enum for state field: ' + k);
            }
        }
        return map;
    }
    create_capabilities_reverse_lookup_map() {
        const map = new Map();
        for (const k in this.capabilities) {
            if (k in this) {
                if (typeof (this[k]) !== 'number') {
                    console.error('Incorrect type for enum for state field: ' + k);
                }
                else {
                    map.set(this[k], k);
                }
            }
            else {
                console.error('Missing enum for state field: ' + k);
            }
        }
        return map;
    }
    get drawingBufferWidth() {
        return this.passthrough === null ? this.fake_drawing_buffer_width : this.passthrough.drawingBufferWidth;
    }
    get drawingBufferHeight() {
        return this.passthrough === null ? this.fake_drawing_buffer_height : this.passthrough.drawingBufferHeight;
    }
    get drawingBufferColorSpace() {
        return this.passthrough === null ? this.fake_drawing_buffer_color_space : this.passthrough.drawingBufferColorSpace;
    }
    makeXRCompatible() {
        var _a;
        if (this.passthrough === null) {
            return Promise.resolve();
        }
        else {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.makeXRCompatible();
        }
    }
    // Any draw call should call this function to fill any active queries with fake data
    fake_query_data_for_draw(index_count) {
        if (this.current_query_any_samples_passed !== null) {
            this.queries.get(this.current_query_any_samples_passed).value += Math.random() * 100.0 * index_count;
        }
        if (this.current_query_any_samples_passed_conservative !== null) {
            this.queries.get(this.current_query_any_samples_passed_conservative).value += Math.random() * 100.0 * index_count;
        }
        if (this.state.TRANSFORM_FEEDBACK_ACTIVE && !this.state.TRANSFORM_FEEDBACK_PAUSED) {
            if (this.current_query_transform_feedback_primitives_written !== null) {
                this.queries.get(this.current_query_transform_feedback_primitives_written).value += index_count * 3;
            }
        }
    }
    constructor(canvas, width, height, capabilities, context_attributes) {
        this.DEPTH_BUFFER_BIT = 256;
        this.STENCIL_BUFFER_BIT = 1024;
        this.COLOR_BUFFER_BIT = 16384;
        this.POINTS = 0;
        this.LINES = 1;
        this.LINE_LOOP = 2;
        this.LINE_STRIP = 3;
        this.TRIANGLES = 4;
        this.TRIANGLE_STRIP = 5;
        this.TRIANGLE_FAN = 6;
        this.ZERO = 0;
        this.ONE = 1;
        this.SRC_COLOR = 768;
        this.ONE_MINUS_SRC_COLOR = 769;
        this.SRC_ALPHA = 770;
        this.ONE_MINUS_SRC_ALPHA = 771;
        this.DST_ALPHA = 772;
        this.ONE_MINUS_DST_ALPHA = 773;
        this.DST_COLOR = 774;
        this.ONE_MINUS_DST_COLOR = 775;
        this.SRC_ALPHA_SATURATE = 776;
        this.FUNC_ADD = 32774;
        this.BLEND_EQUATION = 32777;
        this.BLEND_EQUATION_RGB = 32777;
        this.BLEND_EQUATION_ALPHA = 34877;
        this.FUNC_SUBTRACT = 32778;
        this.FUNC_REVERSE_SUBTRACT = 32779;
        this.BLEND_DST_RGB = 32968;
        this.BLEND_SRC_RGB = 32969;
        this.BLEND_DST_ALPHA = 32970;
        this.BLEND_SRC_ALPHA = 32971;
        this.CONSTANT_COLOR = 32769;
        this.ONE_MINUS_CONSTANT_COLOR = 32770;
        this.CONSTANT_ALPHA = 32771;
        this.ONE_MINUS_CONSTANT_ALPHA = 32772;
        this.BLEND_COLOR = 32773;
        this.ARRAY_BUFFER = 34962;
        this.ELEMENT_ARRAY_BUFFER = 34963;
        this.ARRAY_BUFFER_BINDING = 34964;
        this.ELEMENT_ARRAY_BUFFER_BINDING = 34965;
        this.STREAM_DRAW = 35040;
        this.STATIC_DRAW = 35044;
        this.DYNAMIC_DRAW = 35048;
        this.BUFFER_SIZE = 34660;
        this.BUFFER_USAGE = 34661;
        this.CURRENT_VERTEX_ATTRIB = 34342;
        this.FRONT = 1028;
        this.BACK = 1029;
        this.FRONT_AND_BACK = 1032;
        this.TEXTURE_2D = 3553;
        this.CULL_FACE = 2884;
        this.BLEND = 3042;
        this.DITHER = 3024;
        this.STENCIL_TEST = 2960;
        this.DEPTH_TEST = 2929;
        this.SCISSOR_TEST = 3089;
        this.POLYGON_OFFSET_FILL = 32823;
        this.SAMPLE_ALPHA_TO_COVERAGE = 32926;
        this.SAMPLE_COVERAGE = 32928;
        this.NO_ERROR = 0;
        this.INVALID_ENUM = 1280;
        this.INVALID_VALUE = 1281;
        this.INVALID_OPERATION = 1282;
        this.OUT_OF_MEMORY = 1285;
        this.CW = 2304;
        this.CCW = 2305;
        this.LINE_WIDTH = 2849;
        this.ALIASED_POINT_SIZE_RANGE = 33901;
        this.ALIASED_LINE_WIDTH_RANGE = 33902;
        this.CULL_FACE_MODE = 2885;
        this.FRONT_FACE = 2886;
        this.DEPTH_RANGE = 2928;
        this.DEPTH_WRITEMASK = 2930;
        this.DEPTH_CLEAR_VALUE = 2931;
        this.DEPTH_FUNC = 2932;
        this.STENCIL_CLEAR_VALUE = 2961;
        this.STENCIL_FUNC = 2962;
        this.STENCIL_FAIL = 2964;
        this.STENCIL_PASS_DEPTH_FAIL = 2965;
        this.STENCIL_PASS_DEPTH_PASS = 2966;
        this.STENCIL_REF = 2967;
        this.STENCIL_VALUE_MASK = 2963;
        this.STENCIL_WRITEMASK = 2968;
        this.STENCIL_BACK_FUNC = 34816;
        this.STENCIL_BACK_FAIL = 34817;
        this.STENCIL_BACK_PASS_DEPTH_FAIL = 34818;
        this.STENCIL_BACK_PASS_DEPTH_PASS = 34819;
        this.STENCIL_BACK_REF = 36003;
        this.STENCIL_BACK_VALUE_MASK = 36004;
        this.STENCIL_BACK_WRITEMASK = 36005;
        this.VIEWPORT = 2978;
        this.SCISSOR_BOX = 3088;
        this.COLOR_CLEAR_VALUE = 3106;
        this.COLOR_WRITEMASK = 3107;
        this.UNPACK_ALIGNMENT = 3317;
        this.PACK_ALIGNMENT = 3333;
        this.MAX_TEXTURE_SIZE = 3379;
        this.MAX_VIEWPORT_DIMS = 3386;
        this.SUBPIXEL_BITS = 3408;
        this.RED_BITS = 3410;
        this.GREEN_BITS = 3411;
        this.BLUE_BITS = 3412;
        this.ALPHA_BITS = 3413;
        this.DEPTH_BITS = 3414;
        this.STENCIL_BITS = 3415;
        this.POLYGON_OFFSET_UNITS = 10752;
        this.POLYGON_OFFSET_FACTOR = 32824;
        this.TEXTURE_BINDING_2D = 32873;
        this.SAMPLE_BUFFERS = 32936;
        this.SAMPLES = 32937;
        this.SAMPLE_COVERAGE_VALUE = 32938;
        this.SAMPLE_COVERAGE_INVERT = 32939;
        this.COMPRESSED_TEXTURE_FORMATS = 34467;
        this.DONT_CARE = 4352;
        this.FASTEST = 4353;
        this.NICEST = 4354;
        this.GENERATE_MIPMAP_HINT = 33170;
        this.BYTE = 5120;
        this.UNSIGNED_BYTE = 5121;
        this.SHORT = 5122;
        this.UNSIGNED_SHORT = 5123;
        this.INT = 5124;
        this.UNSIGNED_INT = 5125;
        this.FLOAT = 5126;
        this.DEPTH_COMPONENT = 6402;
        this.ALPHA = 6406;
        this.RGB = 6407;
        this.RGBA = 6408;
        this.LUMINANCE = 6409;
        this.LUMINANCE_ALPHA = 6410;
        this.UNSIGNED_SHORT_4_4_4_4 = 32819;
        this.UNSIGNED_SHORT_5_5_5_1 = 32820;
        this.UNSIGNED_SHORT_5_6_5 = 33635;
        this.FRAGMENT_SHADER = 35632;
        this.VERTEX_SHADER = 35633;
        this.MAX_VERTEX_ATTRIBS = 34921;
        this.MAX_VERTEX_UNIFORM_VECTORS = 36347;
        this.MAX_VARYING_VECTORS = 36348;
        this.MAX_COMBINED_TEXTURE_IMAGE_UNITS = 35661;
        this.MAX_VERTEX_TEXTURE_IMAGE_UNITS = 35660;
        this.MAX_TEXTURE_IMAGE_UNITS = 34930;
        this.MAX_FRAGMENT_UNIFORM_VECTORS = 36349;
        this.SHADER_TYPE = 35663;
        this.DELETE_STATUS = 35712;
        this.LINK_STATUS = 35714;
        this.VALIDATE_STATUS = 35715;
        this.ATTACHED_SHADERS = 35717;
        this.ACTIVE_UNIFORMS = 35718;
        this.ACTIVE_ATTRIBUTES = 35721;
        this.SHADING_LANGUAGE_VERSION = 35724;
        this.CURRENT_PROGRAM = 35725;
        this.NEVER = 512;
        this.LESS = 513;
        this.EQUAL = 514;
        this.LEQUAL = 515;
        this.GREATER = 516;
        this.NOTEQUAL = 517;
        this.GEQUAL = 518;
        this.ALWAYS = 519;
        this.KEEP = 7680;
        this.REPLACE = 7681;
        this.INCR = 7682;
        this.DECR = 7683;
        this.INVERT = 5386;
        this.INCR_WRAP = 34055;
        this.DECR_WRAP = 34056;
        this.VENDOR = 7936;
        this.RENDERER = 7937;
        this.VERSION = 7938;
        this.NEAREST = 9728;
        this.LINEAR = 9729;
        this.NEAREST_MIPMAP_NEAREST = 9984;
        this.LINEAR_MIPMAP_NEAREST = 9985;
        this.NEAREST_MIPMAP_LINEAR = 9986;
        this.LINEAR_MIPMAP_LINEAR = 9987;
        this.TEXTURE_MAG_FILTER = 10240;
        this.TEXTURE_MIN_FILTER = 10241;
        this.TEXTURE_WRAP_S = 10242;
        this.TEXTURE_WRAP_T = 10243;
        this.TEXTURE = 5890;
        this.TEXTURE_CUBE_MAP = 34067;
        this.TEXTURE_BINDING_CUBE_MAP = 34068;
        this.TEXTURE_CUBE_MAP_POSITIVE_X = 34069;
        this.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070;
        this.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071;
        this.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072;
        this.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073;
        this.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074;
        this.MAX_CUBE_MAP_TEXTURE_SIZE = 34076;
        this.TEXTURE0 = 33984;
        this.TEXTURE1 = 33985;
        this.TEXTURE2 = 33986;
        this.TEXTURE3 = 33987;
        this.TEXTURE4 = 33988;
        this.TEXTURE5 = 33989;
        this.TEXTURE6 = 33990;
        this.TEXTURE7 = 33991;
        this.TEXTURE8 = 33992;
        this.TEXTURE9 = 33993;
        this.TEXTURE10 = 33994;
        this.TEXTURE11 = 33995;
        this.TEXTURE12 = 33996;
        this.TEXTURE13 = 33997;
        this.TEXTURE14 = 33998;
        this.TEXTURE15 = 33999;
        this.TEXTURE16 = 34000;
        this.TEXTURE17 = 34001;
        this.TEXTURE18 = 34002;
        this.TEXTURE19 = 34003;
        this.TEXTURE20 = 34004;
        this.TEXTURE21 = 34005;
        this.TEXTURE22 = 34006;
        this.TEXTURE23 = 34007;
        this.TEXTURE24 = 34008;
        this.TEXTURE25 = 34009;
        this.TEXTURE26 = 34010;
        this.TEXTURE27 = 34011;
        this.TEXTURE28 = 34012;
        this.TEXTURE29 = 34013;
        this.TEXTURE30 = 34014;
        this.TEXTURE31 = 34015;
        this.ACTIVE_TEXTURE = 34016;
        this.REPEAT = 10497;
        this.CLAMP_TO_EDGE = 33071;
        this.MIRRORED_REPEAT = 33648;
        this.FLOAT_VEC2 = 35664;
        this.FLOAT_VEC3 = 35665;
        this.FLOAT_VEC4 = 35666;
        this.INT_VEC2 = 35667;
        this.INT_VEC3 = 35668;
        this.INT_VEC4 = 35669;
        this.BOOL = 35670;
        this.BOOL_VEC2 = 35671;
        this.BOOL_VEC3 = 35672;
        this.BOOL_VEC4 = 35673;
        this.FLOAT_MAT2 = 35674;
        this.FLOAT_MAT3 = 35675;
        this.FLOAT_MAT4 = 35676;
        this.SAMPLER_2D = 35678;
        this.SAMPLER_CUBE = 35680;
        this.VERTEX_ATTRIB_ARRAY_ENABLED = 34338;
        this.VERTEX_ATTRIB_ARRAY_SIZE = 34339;
        this.VERTEX_ATTRIB_ARRAY_STRIDE = 34340;
        this.VERTEX_ATTRIB_ARRAY_TYPE = 34341;
        this.VERTEX_ATTRIB_ARRAY_NORMALIZED = 34922;
        this.VERTEX_ATTRIB_ARRAY_POINTER = 34373;
        this.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING = 34975;
        this.IMPLEMENTATION_COLOR_READ_TYPE = 35738;
        this.IMPLEMENTATION_COLOR_READ_FORMAT = 35739;
        this.COMPILE_STATUS = 35713;
        this.LOW_FLOAT = 36336;
        this.MEDIUM_FLOAT = 36337;
        this.HIGH_FLOAT = 36338;
        this.LOW_INT = 36339;
        this.MEDIUM_INT = 36340;
        this.HIGH_INT = 36341;
        this.FRAMEBUFFER = 36160;
        this.RENDERBUFFER = 36161;
        this.RGBA4 = 32854;
        this.RGB5_A1 = 32855;
        this.RGB565 = 36194;
        this.DEPTH_COMPONENT16 = 33189;
        this.STENCIL_INDEX8 = 36168;
        this.DEPTH_STENCIL = 34041;
        this.RENDERBUFFER_WIDTH = 36162;
        this.RENDERBUFFER_HEIGHT = 36163;
        this.RENDERBUFFER_INTERNAL_FORMAT = 36164;
        this.RENDERBUFFER_RED_SIZE = 36176;
        this.RENDERBUFFER_GREEN_SIZE = 36177;
        this.RENDERBUFFER_BLUE_SIZE = 36178;
        this.RENDERBUFFER_ALPHA_SIZE = 36179;
        this.RENDERBUFFER_DEPTH_SIZE = 36180;
        this.RENDERBUFFER_STENCIL_SIZE = 36181;
        this.FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE = 36048;
        this.FRAMEBUFFER_ATTACHMENT_OBJECT_NAME = 36049;
        this.FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL = 36050;
        this.FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE = 36051;
        this.COLOR_ATTACHMENT0 = 36064;
        this.DEPTH_ATTACHMENT = 36096;
        this.STENCIL_ATTACHMENT = 36128;
        this.DEPTH_STENCIL_ATTACHMENT = 33306;
        this.NONE = 0;
        this.FRAMEBUFFER_COMPLETE = 36053;
        this.FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 36054;
        this.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 36055;
        this.FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 36057;
        this.FRAMEBUFFER_UNSUPPORTED = 36061;
        this.FRAMEBUFFER_BINDING = 36006;
        this.RENDERBUFFER_BINDING = 36007;
        this.MAX_RENDERBUFFER_SIZE = 34024;
        this.INVALID_FRAMEBUFFER_OPERATION = 1286;
        this.UNPACK_FLIP_Y_WEBGL = 37440;
        this.UNPACK_PREMULTIPLY_ALPHA_WEBGL = 37441;
        this.CONTEXT_LOST_WEBGL = 37442;
        this.UNPACK_COLORSPACE_CONVERSION_WEBGL = 37443;
        this.BROWSER_DEFAULT_WEBGL = 37444;
        this.READ_BUFFER = 3074;
        this.UNPACK_ROW_LENGTH = 3314;
        this.UNPACK_SKIP_ROWS = 3315;
        this.UNPACK_SKIP_PIXELS = 3316;
        this.PACK_ROW_LENGTH = 3330;
        this.PACK_SKIP_ROWS = 3331;
        this.PACK_SKIP_PIXELS = 3332;
        this.COLOR = 6144;
        this.DEPTH = 6145;
        this.STENCIL = 6146;
        this.RED = 6403;
        this.RGB8 = 32849;
        this.RGBA8 = 32856;
        this.RGB10_A2 = 32857;
        this.TEXTURE_BINDING_3D = 32874;
        this.UNPACK_SKIP_IMAGES = 32877;
        this.UNPACK_IMAGE_HEIGHT = 32878;
        this.TEXTURE_3D = 32879;
        this.TEXTURE_WRAP_R = 32882;
        this.MAX_3D_TEXTURE_SIZE = 32883;
        this.UNSIGNED_INT_2_10_10_10_REV = 33640;
        this.MAX_ELEMENTS_VERTICES = 33000;
        this.MAX_ELEMENTS_INDICES = 33001;
        this.TEXTURE_MIN_LOD = 33082;
        this.TEXTURE_MAX_LOD = 33083;
        this.TEXTURE_BASE_LEVEL = 33084;
        this.TEXTURE_MAX_LEVEL = 33085;
        this.MIN = 32775;
        this.MAX = 32776;
        this.DEPTH_COMPONENT24 = 33190;
        this.MAX_TEXTURE_LOD_BIAS = 34045;
        this.TEXTURE_COMPARE_MODE = 34892;
        this.TEXTURE_COMPARE_FUNC = 34893;
        this.CURRENT_QUERY = 34917;
        this.QUERY_RESULT = 34918;
        this.QUERY_RESULT_AVAILABLE = 34919;
        this.STREAM_READ = 35041;
        this.STREAM_COPY = 35042;
        this.STATIC_READ = 35045;
        this.STATIC_COPY = 35046;
        this.DYNAMIC_READ = 35049;
        this.DYNAMIC_COPY = 35050;
        this.MAX_DRAW_BUFFERS = 34852;
        this.DRAW_BUFFER0 = 34853;
        this.DRAW_BUFFER1 = 34854;
        this.DRAW_BUFFER2 = 34855;
        this.DRAW_BUFFER3 = 34856;
        this.DRAW_BUFFER4 = 34857;
        this.DRAW_BUFFER5 = 34858;
        this.DRAW_BUFFER6 = 34859;
        this.DRAW_BUFFER7 = 34860;
        this.DRAW_BUFFER8 = 34861;
        this.DRAW_BUFFER9 = 34862;
        this.DRAW_BUFFER10 = 34863;
        this.DRAW_BUFFER11 = 34864;
        this.DRAW_BUFFER12 = 34865;
        this.DRAW_BUFFER13 = 34866;
        this.DRAW_BUFFER14 = 34867;
        this.DRAW_BUFFER15 = 34868;
        this.MAX_FRAGMENT_UNIFORM_COMPONENTS = 35657;
        this.MAX_VERTEX_UNIFORM_COMPONENTS = 35658;
        this.SAMPLER_3D = 35679;
        this.SAMPLER_2D_SHADOW = 35682;
        this.FRAGMENT_SHADER_DERIVATIVE_HINT = 35723;
        this.PIXEL_PACK_BUFFER = 35051;
        this.PIXEL_UNPACK_BUFFER = 35052;
        this.PIXEL_PACK_BUFFER_BINDING = 35053;
        this.PIXEL_UNPACK_BUFFER_BINDING = 35055;
        this.FLOAT_MAT2x3 = 35685;
        this.FLOAT_MAT2x4 = 35686;
        this.FLOAT_MAT3x2 = 35687;
        this.FLOAT_MAT3x4 = 35688;
        this.FLOAT_MAT4x2 = 35689;
        this.FLOAT_MAT4x3 = 35690;
        this.SRGB = 35904;
        this.SRGB8 = 35905;
        this.SRGB8_ALPHA8 = 35907;
        this.COMPARE_REF_TO_TEXTURE = 34894;
        this.RGBA32F = 34836;
        this.RGB32F = 34837;
        this.RGBA16F = 34842;
        this.RGB16F = 34843;
        this.VERTEX_ATTRIB_ARRAY_INTEGER = 35069;
        this.MAX_ARRAY_TEXTURE_LAYERS = 35071;
        this.MIN_PROGRAM_TEXEL_OFFSET = 35076;
        this.MAX_PROGRAM_TEXEL_OFFSET = 35077;
        this.MAX_VARYING_COMPONENTS = 35659;
        this.TEXTURE_2D_ARRAY = 35866;
        this.TEXTURE_BINDING_2D_ARRAY = 35869;
        this.R11F_G11F_B10F = 35898;
        this.UNSIGNED_INT_10F_11F_11F_REV = 35899;
        this.RGB9_E5 = 35901;
        this.UNSIGNED_INT_5_9_9_9_REV = 35902;
        this.TRANSFORM_FEEDBACK_BUFFER_MODE = 35967;
        this.MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS = 35968;
        this.TRANSFORM_FEEDBACK_VARYINGS = 35971;
        this.TRANSFORM_FEEDBACK_BUFFER_START = 35972;
        this.TRANSFORM_FEEDBACK_BUFFER_SIZE = 35973;
        this.TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN = 35976;
        this.RASTERIZER_DISCARD = 35977;
        this.MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS = 35978;
        this.MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS = 35979;
        this.INTERLEAVED_ATTRIBS = 35980;
        this.SEPARATE_ATTRIBS = 35981;
        this.TRANSFORM_FEEDBACK_BUFFER = 35982;
        this.TRANSFORM_FEEDBACK_BUFFER_BINDING = 35983;
        this.RGBA32UI = 36208;
        this.RGB32UI = 36209;
        this.RGBA16UI = 36214;
        this.RGB16UI = 36215;
        this.RGBA8UI = 36220;
        this.RGB8UI = 36221;
        this.RGBA32I = 36226;
        this.RGB32I = 36227;
        this.RGBA16I = 36232;
        this.RGB16I = 36233;
        this.RGBA8I = 36238;
        this.RGB8I = 36239;
        this.RED_INTEGER = 36244;
        this.RGB_INTEGER = 36248;
        this.RGBA_INTEGER = 36249;
        this.SAMPLER_2D_ARRAY = 36289;
        this.SAMPLER_2D_ARRAY_SHADOW = 36292;
        this.SAMPLER_CUBE_SHADOW = 36293;
        this.UNSIGNED_INT_VEC2 = 36294;
        this.UNSIGNED_INT_VEC3 = 36295;
        this.UNSIGNED_INT_VEC4 = 36296;
        this.INT_SAMPLER_2D = 36298;
        this.INT_SAMPLER_3D = 36299;
        this.INT_SAMPLER_CUBE = 36300;
        this.INT_SAMPLER_2D_ARRAY = 36303;
        this.UNSIGNED_INT_SAMPLER_2D = 36306;
        this.UNSIGNED_INT_SAMPLER_3D = 36307;
        this.UNSIGNED_INT_SAMPLER_CUBE = 36308;
        this.UNSIGNED_INT_SAMPLER_2D_ARRAY = 36311;
        this.DEPTH_COMPONENT32F = 36012;
        this.DEPTH32F_STENCIL8 = 36013;
        this.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269;
        this.FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING = 33296;
        this.FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE = 33297;
        this.FRAMEBUFFER_ATTACHMENT_RED_SIZE = 33298;
        this.FRAMEBUFFER_ATTACHMENT_GREEN_SIZE = 33299;
        this.FRAMEBUFFER_ATTACHMENT_BLUE_SIZE = 33300;
        this.FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE = 33301;
        this.FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE = 33302;
        this.FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE = 33303;
        this.FRAMEBUFFER_DEFAULT = 33304;
        this.UNSIGNED_INT_24_8 = 34042;
        this.DEPTH24_STENCIL8 = 35056;
        this.UNSIGNED_NORMALIZED = 35863;
        this.DRAW_FRAMEBUFFER_BINDING = 36006;
        this.READ_FRAMEBUFFER = 36008;
        this.DRAW_FRAMEBUFFER = 36009;
        this.READ_FRAMEBUFFER_BINDING = 36010;
        this.RENDERBUFFER_SAMPLES = 36011;
        this.FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER = 36052;
        this.MAX_COLOR_ATTACHMENTS = 36063;
        this.COLOR_ATTACHMENT1 = 36065;
        this.COLOR_ATTACHMENT2 = 36066;
        this.COLOR_ATTACHMENT3 = 36067;
        this.COLOR_ATTACHMENT4 = 36068;
        this.COLOR_ATTACHMENT5 = 36069;
        this.COLOR_ATTACHMENT6 = 36070;
        this.COLOR_ATTACHMENT7 = 36071;
        this.COLOR_ATTACHMENT8 = 36072;
        this.COLOR_ATTACHMENT9 = 36073;
        this.COLOR_ATTACHMENT10 = 36074;
        this.COLOR_ATTACHMENT11 = 36075;
        this.COLOR_ATTACHMENT12 = 36076;
        this.COLOR_ATTACHMENT13 = 36077;
        this.COLOR_ATTACHMENT14 = 36078;
        this.COLOR_ATTACHMENT15 = 36079;
        this.FRAMEBUFFER_INCOMPLETE_MULTISAMPLE = 36182;
        this.MAX_SAMPLES = 36183;
        this.HALF_FLOAT = 5131;
        this.RG = 33319;
        this.RG_INTEGER = 33320;
        this.R8 = 33321;
        this.RG8 = 33323;
        this.R16F = 33325;
        this.R32F = 33326;
        this.RG16F = 33327;
        this.RG32F = 33328;
        this.R8I = 33329;
        this.R8UI = 33330;
        this.R16I = 33331;
        this.R16UI = 33332;
        this.R32I = 33333;
        this.R32UI = 33334;
        this.RG8I = 33335;
        this.RG8UI = 33336;
        this.RG16I = 33337;
        this.RG16UI = 33338;
        this.RG32I = 33339;
        this.RG32UI = 33340;
        this.VERTEX_ARRAY_BINDING = 34229;
        this.R8_SNORM = 36756;
        this.RG8_SNORM = 36757;
        this.RGB8_SNORM = 36758;
        this.RGBA8_SNORM = 36759;
        this.SIGNED_NORMALIZED = 36764;
        this.COPY_READ_BUFFER = 36662;
        this.COPY_WRITE_BUFFER = 36663;
        this.COPY_READ_BUFFER_BINDING = 36662;
        this.COPY_WRITE_BUFFER_BINDING = 36663;
        this.UNIFORM_BUFFER = 35345;
        this.UNIFORM_BUFFER_BINDING = 35368;
        this.UNIFORM_BUFFER_START = 35369;
        this.UNIFORM_BUFFER_SIZE = 35370;
        this.MAX_VERTEX_UNIFORM_BLOCKS = 35371;
        this.MAX_FRAGMENT_UNIFORM_BLOCKS = 35373;
        this.MAX_COMBINED_UNIFORM_BLOCKS = 35374;
        this.MAX_UNIFORM_BUFFER_BINDINGS = 35375;
        this.MAX_UNIFORM_BLOCK_SIZE = 35376;
        this.MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS = 35377;
        this.MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS = 35379;
        this.UNIFORM_BUFFER_OFFSET_ALIGNMENT = 35380;
        this.ACTIVE_UNIFORM_BLOCKS = 35382;
        this.UNIFORM_TYPE = 35383;
        this.UNIFORM_SIZE = 35384;
        this.UNIFORM_BLOCK_INDEX = 35386;
        this.UNIFORM_OFFSET = 35387;
        this.UNIFORM_ARRAY_STRIDE = 35388;
        this.UNIFORM_MATRIX_STRIDE = 35389;
        this.UNIFORM_IS_ROW_MAJOR = 35390;
        this.UNIFORM_BLOCK_BINDING = 35391;
        this.UNIFORM_BLOCK_DATA_SIZE = 35392;
        this.UNIFORM_BLOCK_ACTIVE_UNIFORMS = 35394;
        this.UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES = 35395;
        this.UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER = 35396;
        this.UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER = 35398;
        this.INVALID_INDEX = 4294967295;
        this.MAX_VERTEX_OUTPUT_COMPONENTS = 37154;
        this.MAX_FRAGMENT_INPUT_COMPONENTS = 37157;
        this.MAX_SERVER_WAIT_TIMEOUT = 37137;
        this.OBJECT_TYPE = 37138;
        this.SYNC_CONDITION = 37139;
        this.SYNC_STATUS = 37140;
        this.SYNC_FLAGS = 37141;
        this.SYNC_FENCE = 37142;
        this.SYNC_GPU_COMMANDS_COMPLETE = 37143;
        this.UNSIGNALED = 37144;
        this.SIGNALED = 37145;
        this.ALREADY_SIGNALED = 37146;
        this.TIMEOUT_EXPIRED = 37147;
        this.CONDITION_SATISFIED = 37148;
        this.WAIT_FAILED = 37149;
        this.SYNC_FLUSH_COMMANDS_BIT = 1;
        this.VERTEX_ATTRIB_ARRAY_DIVISOR = 35070;
        this.ANY_SAMPLES_PASSED = 35887;
        this.ANY_SAMPLES_PASSED_CONSERVATIVE = 36202;
        this.SAMPLER_BINDING = 35097;
        this.RGB10_A2UI = 36975;
        this.INT_2_10_10_10_REV = 36255;
        this.TRANSFORM_FEEDBACK = 36386;
        this.TRANSFORM_FEEDBACK_PAUSED = 36387;
        this.TRANSFORM_FEEDBACK_ACTIVE = 36388;
        this.TRANSFORM_FEEDBACK_BINDING = 36389;
        this.TEXTURE_IMMUTABLE_FORMAT = 37167;
        this.MAX_ELEMENT_INDEX = 36203;
        this.TEXTURE_IMMUTABLE_LEVELS = 33503;
        this.TIMEOUT_IGNORED = -1;
        this.MAX_CLIENT_WAIT_TIMEOUT_WEBGL = 37447;
        this.passthrough = null;
        this.programs = new Map();
        this.shaders = new Map();
        this.buffers = new Map();
        this.textures = new Map();
        this.framebuffers = new Map();
        this.renderbuffers = new Map();
        this.queries = new Map();
        this.samplers = new Map();
        this.transform_feedbacks = new Map();
        this.currently_bound_buffers = new Map();
        this.currently_bound_textures = new Map();
        this.active_samplers = [];
        this.current_query_any_samples_passed = null;
        this.current_query_any_samples_passed_conservative = null;
        this.current_query_transform_feedback_primitives_written = null;
        this.fake_drawing_buffer_color_space = 'srgb';
        this.supported_extension = [
            'EXT_color_buffer_float'
        ];
        this.canvas = canvas;
        this.fake_drawing_buffer_width = width;
        this.fake_drawing_buffer_height = height;
        this.capabilities = capabilities;
        this.context_attributes = context_attributes;
        this.state = create_default_context_state(this.capabilities, { x: 0, y: 0, width: width, height: height });
        this.default_sampler_configuration = {
            min_filter: this.NEAREST_MIPMAP_LINEAR,
            mag_filter: this.LINEAR,
            wrap_s: this.REPEAT,
            wrap_t: this.REPEAT,
            wrap_r: this.REPEAT,
            min_lod: 0,
            max_lod: 1000,
            compare_func: this.LEQUAL,
            compare_mode: this.NONE
        };
        this.state_field_reverse_lookup_map = this.create_state_reverse_lookup_map();
        this.capabilities_field_reverse_lookup_map = this.create_capabilities_reverse_lookup_map();
        for (let i = 0; i < 32; i++) {
            this.active_samplers.push(null);
        }
        const GLsizeiptr_v = 0;
        const GLenum_v = 0;
        const GLbitfield_v = 0;
        const GLuint_v = 0;
        const GLclampf_v = 0;
        assert(typeof GLsizeiptr_v === 'number', 'GLsizeiptr is not a number');
        assert(typeof GLenum_v === 'number', 'GLenum is not a number');
        assert(typeof GLbitfield_v === 'number', 'GLbitfield is not a number');
        assert(typeof GLuint_v === 'number', 'GLuint is not a number');
        assert(typeof GLclampf_v === 'number', 'GLclampf is not a number');
        const GLboolean_v = true;
        assert(typeof GLboolean_v === 'boolean', 'GLboolean_v is not a boolean');
    }
    getExtension(name) {
        if (this.passthrough !== null) {
            // Block extensions that we do not support
            if (this.supported_extension.indexOf(name) >= 0) {
                return this.passthrough.getExtension(name);
            }
            else {
                return null;
            }
        }
        else {
            // TODO: Remove with WebGL2 support
            if (name === 'EXT_color_buffer_float') {
                const ext = {};
                return ext;
            }
            else if (this.supported_extension.indexOf(name) >= 0) {
                console.error('WebGL Mock: missing supported extension mock implementation');
            }
        }
        return null;
    }
    getSupportedExtensions() {
        return this.supported_extension;
    }
    activeTexture(textureUnit) {
        var _a;
        this.state.ACTIVE_TEXTURE = textureUnit;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.activeTexture(textureUnit);
    }
    attachShader(program, shader) {
        var _a;
        if (this.programs.has(program) && this.shaders.has(shader)) {
            this.programs.get(program).attached_shaders.push(this.shaders.get(shader));
        }
        else {
            console.error('Invalid program or shader.');
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.attachShader(program, shader);
    }
    bindAttribLocation(program, index, name) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindAttribLocation(program, index, name);
    }
    internal_update_buffer_binding_state(target, buffer) {
        this.currently_bound_buffers.set(target, buffer);
        if (target === this.ARRAY_BUFFER) {
            this.state.ARRAY_BUFFER_BINDING = buffer;
        }
        else if (target === this.ELEMENT_ARRAY_BUFFER) {
            this.state.ELEMENT_ARRAY_BUFFER_BINDING = buffer;
        }
        else if (target === this.COPY_READ_BUFFER) {
            this.state.COPY_READ_BUFFER_BINDING = buffer;
        }
        else if (target === this.COPY_WRITE_BUFFER) {
            this.state.COPY_WRITE_BUFFER_BINDING = buffer;
        }
        else if (target === this.PIXEL_PACK_BUFFER) {
            this.state.PIXEL_PACK_BUFFER_BINDING = buffer;
        }
        else if (target === this.PIXEL_UNPACK_BUFFER) {
            this.state.PIXEL_UNPACK_BUFFER_BINDING = buffer;
        }
        else if (target === this.TRANSFORM_FEEDBACK_BUFFER) {
            this.state.TRANSFORM_FEEDBACK_BUFFER_BINDING = buffer;
        }
        else if (target === this.UNIFORM_BUFFER) {
            this.state.UNIFORM_BUFFER_BINDING = buffer;
        }
    }
    bindBuffer(target, buffer) {
        var _a;
        this.internal_update_buffer_binding_state(target, buffer);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindBuffer(target, buffer);
    }
    bindBufferBase(target, index, buffer) {
        var _a;
        this.internal_update_buffer_binding_state(target, buffer);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindBufferBase(target, index, buffer);
    }
    bindBufferRange(target, index, buffer, offset, size) {
        var _a;
        this.internal_update_buffer_binding_state(target, buffer);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindBufferRange(target, index, buffer, offset, size);
    }
    blitFramebuffer(srcX0, srcY0, srcX1, srcY1, dstX0, dstY0, dstX1, dstY1, mask, filter) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.blitFramebuffer(srcX0, srcY0, srcX1, srcY1, dstX0, dstY0, dstX1, dstY1, mask, filter);
    }
    clearBufferfi(buffer, drawbuffer, depth, stencil) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clearBufferfi(buffer, drawbuffer, depth, stencil);
    }
    clearBufferfv(buffer, drawbuffer, values, srcOffset) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clearBufferfv(buffer, drawbuffer, values, srcOffset);
    }
    clearBufferiv(buffer, drawbuffer, values, srcOffset) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clearBufferiv(buffer, drawbuffer, values, srcOffset);
    }
    clearBufferuiv(buffer, drawbuffer, values, srcOffset) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clearBufferuiv(buffer, drawbuffer, values, srcOffset);
    }
    bindFramebuffer(target, framebuffer) {
        var _a;
        if (target === this.FRAMEBUFFER) {
            this.state.FRAMEBUFFER_BINDING = framebuffer;
            this.state.READ_FRAMEBUFFER_BINDING = framebuffer;
            this.state.DRAW_FRAMEBUFFER_BINDING = framebuffer;
        }
        else if (target === this.DRAW_FRAMEBUFFER) {
            this.state.FRAMEBUFFER_BINDING = framebuffer;
            this.state.DRAW_FRAMEBUFFER_BINDING = framebuffer;
        }
        else if (target === this.READ_FRAMEBUFFER) {
            this.state.READ_FRAMEBUFFER_BINDING = framebuffer;
        }
        if (framebuffer !== null) {
            const found_framebuffer = this.framebuffers.get(framebuffer);
            // Make sure the framebuffer wasn't deleted.
            if (found_framebuffer) {
                found_framebuffer.is_framebuffer = true;
            }
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindFramebuffer(target, framebuffer);
    }
    bindRenderbuffer(target, renderbuffer) {
        var _a;
        this.state.RENDERBUFFER_BINDING = renderbuffer;
        if (renderbuffer !== null) {
            const found_renderbuffer = this.renderbuffers.get(renderbuffer);
            if (found_renderbuffer) {
                found_renderbuffer.is_renderbuffer = true;
            }
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindRenderbuffer(target, renderbuffer);
    }
    bindTexture(target, texture) {
        var _a;
        if (target === this.TEXTURE_2D) {
            this.state.TEXTURE_BINDING_2D = texture;
        }
        if (target === this.TEXTURE_2D_ARRAY) {
            this.state.TEXTURE_BINDING_2D_ARRAY = texture;
        }
        if (target === this.TEXTURE_CUBE_MAP) {
            this.state.TEXTURE_BINDING_CUBE_MAP = texture;
        }
        if (target === this.TEXTURE_3D) {
            this.state.TEXTURE_BINDING_3D = texture;
        }
        this.currently_bound_textures.set(target, texture);
        if (texture !== null) {
            this.textures.get(texture).is_texture = true;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindTexture(target, texture);
    }
    blendColor(red, green, blue, alpha) {
        var _a;
        this.state.BLEND_COLOR.set([red, green, blue, alpha]);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.blendColor(red, green, blue, alpha);
    }
    blendEquation(mode) {
        var _a;
        this.state.BLEND_EQUATION = mode;
        this.state.BLEND_EQUATION_RGB = mode;
        this.state.BLEND_EQUATION_ALPHA = mode;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.blendEquation(mode);
    }
    blendEquationSeparate(modeRGB, modeAlpha) {
        var _a;
        this.state.BLEND_EQUATION = modeRGB;
        this.state.BLEND_EQUATION_RGB = modeRGB;
        this.state.BLEND_EQUATION_ALPHA = modeAlpha;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.blendEquationSeparate(modeRGB, modeAlpha);
    }
    blendFunc(sfactor, dfactor) {
        var _a;
        this.state.BLEND_SRC_RGB = sfactor;
        this.state.BLEND_SRC_ALPHA = sfactor;
        this.state.BLEND_DST_RGB = dfactor;
        this.state.BLEND_DST_ALPHA = dfactor;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.blendFunc(sfactor, dfactor);
    }
    blendFuncSeparate(srcRGB, dstRGB, srcAlpha, dstAlpha) {
        var _a;
        this.state.BLEND_SRC_RGB = srcRGB;
        this.state.BLEND_SRC_ALPHA = srcAlpha;
        this.state.BLEND_DST_RGB = dstRGB;
        this.state.BLEND_DST_ALPHA = dstAlpha;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.blendFuncSeparate(srcRGB, dstRGB, srcAlpha, dstAlpha);
    }
    bufferData(target, srcData_or_size, usage, srcOffset, length) {
        var _a, _b, _c, _d;
        const buffer = (_a = this.currently_bound_buffers.get(target)) !== null && _a !== void 0 ? _a : null;
        let mock_buffer = null;
        if (buffer === null) {
            console.error('bufferData: No buffer bound');
        }
        else {
            if (this.buffers.has(buffer)) {
                mock_buffer = this.buffers.get(buffer);
            }
            else {
                console.error('bufferData: Missing buffer in mock');
            }
        }
        if (mock_buffer !== null) {
            mock_buffer.is_initialized = true;
            mock_buffer.buffer_usage = usage;
            let size = 0;
            if (typeof srcData_or_size === 'number') {
                size = srcData_or_size;
            }
            else if (length !== undefined) {
                size = length;
            }
            else if (srcData_or_size === null) {
                // Fetch previous state
                size = mock_buffer.buffer_size;
            }
            else {
                size = srcData_or_size.byteLength - (srcOffset !== null && srcOffset !== void 0 ? srcOffset : 0);
            }
            mock_buffer.buffer_size = size;
        }
        if (typeof srcData_or_size === 'number') {
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.bufferData(target, srcData_or_size, usage);
        }
        else if (srcOffset !== undefined && srcData_or_size !== null) {
            return (_c = this.passthrough) === null || _c === void 0 ? void 0 : _c.bufferData(target, srcData_or_size, usage, srcOffset, length);
        }
        else {
            return (_d = this.passthrough) === null || _d === void 0 ? void 0 : _d.bufferData(target, srcData_or_size, usage);
        }
    }
    bufferSubData(target, dstByteOffset, srcData, srcOffset, length) {
        var _a, _b;
        if (srcOffset === undefined) {
            (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bufferSubData(target, dstByteOffset, srcData);
        }
        else {
            (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.bufferSubData(target, dstByteOffset, srcData, srcOffset, length);
        }
    }
    checkFramebufferStatus(target) {
        if (this.passthrough === null) {
            // Always succeed. VERIFY
            return this.FRAMEBUFFER_COMPLETE;
        }
        else {
            return this.passthrough.checkFramebufferStatus(target);
        }
    }
    clear(mask) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clear(mask);
    }
    clearColor(red, green, blue, alpha) {
        var _a;
        this.state.COLOR_CLEAR_VALUE.set([red, green, blue, alpha]);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clearColor(red, green, blue, alpha);
    }
    clearDepth(depth) {
        var _a;
        this.state.DEPTH_CLEAR_VALUE = depth;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clearDepth(depth);
    }
    clearStencil(s) {
        var _a;
        this.state.STENCIL_CLEAR_VALUE = s;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.clearStencil(s);
    }
    colorMask(red, green, blue, alpha) {
        var _a;
        this.state.COLOR_WRITEMASK[0] = red;
        this.state.COLOR_WRITEMASK[1] = green;
        this.state.COLOR_WRITEMASK[2] = blue;
        this.state.COLOR_WRITEMASK[3] = alpha;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.colorMask(red, green, blue, alpha);
    }
    compileShader(shader) {
        var _a;
        (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.compileShader(shader);
    }
    compressedTexImage2D(target, level, internalformat, width, height, border, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride) {
        var _a, _b;
        assert(border === 0, "compressedTexImage2D: 'border' parameter is not zero.");
        if (typeof srcData_or_imageSize === 'number' && srcOffset_or_offset !== undefined) {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.compressedTexImage2D(target, level, internalformat, width, height, border, srcData_or_imageSize, srcOffset_or_offset);
        }
        else if (typeof srcData_or_imageSize !== 'number') {
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.compressedTexImage2D(target, level, internalformat, width, height, border, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride);
        }
        else {
            throw new Error('Incorrect overload resoluton in WebGLMock');
        }
    }
    compressedTexImage3D(target, level, internalformat, width, height, depth, border, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride) {
        var _a, _b;
        assert(border === 0, "compressedTexImage3D: 'border' parameter is not zero.");
        if (typeof srcData_or_imageSize === 'number' && srcOffset_or_offset !== undefined) {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.compressedTexImage3D(target, level, internalformat, width, height, depth, border, srcData_or_imageSize, srcOffset_or_offset);
        }
        else if (typeof srcData_or_imageSize !== 'number') {
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.compressedTexImage3D(target, level, internalformat, width, height, depth, border, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride);
        }
        else {
            throw new Error('Incorrect overload resoluton in WebGLMock');
        }
    }
    compressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride) {
        var _a, _b;
        if (typeof srcData_or_imageSize === 'number' && srcOffset_or_offset !== undefined) {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.compressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, srcData_or_imageSize, srcOffset_or_offset);
        }
        else if (typeof srcData_or_imageSize !== 'number') {
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.compressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride);
        }
        else {
            throw new Error('Incorrect overload resoluton in WebGLMock');
        }
    }
    compressedTexSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride) {
        var _a, _b;
        if (typeof srcData_or_imageSize === 'number' && srcOffset_or_offset !== undefined) {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.compressedTexSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, srcData_or_imageSize, srcOffset_or_offset);
        }
        else if (typeof srcData_or_imageSize !== 'number') {
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.compressedTexSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, srcData_or_imageSize, srcOffset_or_offset, srcLengthOverride);
        }
        else {
            throw new Error('Incorrect overload resoluton in WebGLMock');
        }
    }
    copyTexImage2D(target, level, internalformat, x, y, width, height, border) {
        var _a;
        assert(border === 0, "copyTexImage2D: 'border' parameter is not zero.");
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.copyTexImage2D(target, level, internalformat, x, y, width, height, border);
    }
    copyTexSubImage2D(target, level, xoffset, yoffset, x, y, width, height) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.copyTexSubImage2D(target, level, xoffset, yoffset, x, y, width, height);
    }
    copyTexSubImage3D(target, level, xoffset, yoffset, zoffset, x, y, width, height) {
        var _a;
        (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.copyTexSubImage3D(target, level, xoffset, yoffset, zoffset, x, y, width, height);
    }
    createBuffer() {
        let buffer;
        if (this.passthrough === null) {
            buffer = {};
        }
        else {
            buffer = this.passthrough.createBuffer();
        }
        if (buffer === null)
            return null;
        this.buffers.set(buffer, {
            actual_buffer: buffer,
            is_initialized: false,
            // Initial values according to docs
            buffer_size: 0,
            buffer_usage: this.STATIC_DRAW
        });
        return buffer;
    }
    createFramebuffer() {
        let framebuffer;
        if (this.passthrough === null) {
            framebuffer = {};
        }
        else {
            framebuffer = this.passthrough.createFramebuffer();
        }
        if (framebuffer === null)
            return null;
        this.framebuffers.set(framebuffer, {
            actual_framebuffer: framebuffer,
            is_framebuffer: false
        });
        return framebuffer;
    }
    createProgram() {
        let program;
        if (this.passthrough === null) {
            program = {};
        }
        else {
            program = this.passthrough.createProgram();
        }
        if (program === null)
            return null;
        this.programs.set(program, {
            actual_program: program,
            attached_shaders: [],
            fake_attrib_indices: new Map(),
            fake_uniform_indices: new Map(),
            fake_uniform_block_indices: new Map(),
            is_program: false,
            validate_status: false,
            link_status: false
        });
        return program;
    }
    createRenderbuffer() {
        let renderbuffer;
        if (this.passthrough === null) {
            renderbuffer = {};
        }
        else {
            renderbuffer = this.passthrough.createRenderbuffer();
        }
        if (renderbuffer === null)
            return null;
        this.renderbuffers.set(renderbuffer, {
            actual_renderbuffer: renderbuffer,
            is_renderbuffer: false
        });
        return renderbuffer;
    }
    createShader(type) {
        let shader;
        if (this.passthrough === null) {
            shader = {};
        }
        else {
            shader = this.passthrough.createShader(type);
        }
        if (shader === null)
            return null;
        this.shaders.set(shader, {
            actual_shader: shader,
            source: null,
            type: type
        });
        return shader;
    }
    createTexture() {
        let texture;
        if (this.passthrough === null) {
            texture = {};
        }
        else {
            texture = this.passthrough.createTexture();
        }
        if (texture === null)
            return null;
        this.textures.set(texture, {
            actual_texture: texture,
            immutable_format: false,
            immutable_levels: 0,
            base_level: 0,
            max_level: 1000,
            sampler_configuration: Object.assign({}, this.default_sampler_configuration),
            is_texture: false
        });
        return texture;
    }
    cullFace(mode) {
        var _a;
        this.state.CULL_FACE_MODE = mode;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.cullFace(mode);
    }
    deleteBuffer(buffer) {
        var _a;
        if (buffer !== null) {
            this.buffers.delete(buffer);
            for (const [target, bound_buffer] of this.currently_bound_buffers.entries()) {
                if (bound_buffer === buffer) {
                    this.currently_bound_buffers.set(target, null);
                }
            }
            if (this.state.ARRAY_BUFFER_BINDING === buffer) {
                this.state.ARRAY_BUFFER_BINDING = null;
            }
            else if (buffer === this.state.ELEMENT_ARRAY_BUFFER_BINDING) {
                this.state.ELEMENT_ARRAY_BUFFER_BINDING = null;
            }
            else if (buffer === this.state.COPY_READ_BUFFER_BINDING) {
                this.state.COPY_READ_BUFFER_BINDING = null;
            }
            else if (buffer === this.state.COPY_WRITE_BUFFER_BINDING) {
                this.state.COPY_WRITE_BUFFER_BINDING = null;
            }
            else if (buffer === this.state.PIXEL_PACK_BUFFER_BINDING) {
                this.state.PIXEL_PACK_BUFFER_BINDING = null;
            }
            else if (buffer === this.state.PIXEL_UNPACK_BUFFER_BINDING) {
                this.state.PIXEL_UNPACK_BUFFER_BINDING = null;
            }
            else if (buffer === this.state.TRANSFORM_FEEDBACK_BUFFER_BINDING) {
                this.state.TRANSFORM_FEEDBACK_BUFFER_BINDING = null;
            }
            else if (buffer === this.state.UNIFORM_BUFFER_BINDING) {
                this.state.UNIFORM_BUFFER_BINDING = null;
            }
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteBuffer(buffer);
    }
    deleteFramebuffer(framebuffer) {
        var _a;
        if (this.state.FRAMEBUFFER_BINDING === framebuffer) {
            this.state.FRAMEBUFFER_BINDING = null;
        }
        if (this.state.DRAW_FRAMEBUFFER_BINDING === framebuffer) {
            this.state.DRAW_FRAMEBUFFER_BINDING = null;
        }
        if (this.state.READ_FRAMEBUFFER_BINDING === framebuffer) {
            this.state.READ_FRAMEBUFFER_BINDING = null;
        }
        if (framebuffer != null)
            this.framebuffers.delete(framebuffer);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteFramebuffer(framebuffer);
    }
    deleteProgram(program) {
        var _a;
        if (program !== null)
            this.programs.delete(program);
        if (this.state.CURRENT_PROGRAM === program) {
            this.state.CURRENT_PROGRAM = null;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteProgram(program);
    }
    deleteRenderbuffer(renderbuffer) {
        var _a;
        if (this.state.RENDERBUFFER_BINDING === renderbuffer) {
            this.state.RENDERBUFFER_BINDING = null;
        }
        if (renderbuffer != null)
            this.renderbuffers.delete(renderbuffer);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteRenderbuffer(renderbuffer);
    }
    deleteShader(shader) {
        var _a;
        if (shader !== null)
            this.shaders.delete(shader);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteShader(shader);
    }
    deleteTexture(texture) {
        var _a;
        if (this.state.TEXTURE_BINDING_2D === texture) {
            this.state.TEXTURE_BINDING_2D = null;
        }
        if (this.state.TEXTURE_BINDING_2D_ARRAY === texture) {
            this.state.TEXTURE_BINDING_2D_ARRAY = null;
        }
        if (this.state.TEXTURE_BINDING_CUBE_MAP === texture) {
            this.state.TEXTURE_BINDING_CUBE_MAP = null;
        }
        if (this.state.TEXTURE_BINDING_3D === texture) {
            this.state.TEXTURE_BINDING_3D = null;
        }
        if (texture !== null && this.textures.has(texture)) {
            this.textures.delete(texture);
            for (const [target, bound_texture] of this.currently_bound_textures.entries()) {
                if (bound_texture === texture) {
                    this.currently_bound_textures.set(target, null);
                }
            }
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteTexture(texture);
    }
    drawBuffers(buffers) {
        var _a;
        for (let i = 0; i < buffers.length; i++) {
            this.state['DRAW_BUFFER' + i.toString()] = buffers[i];
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.drawBuffers(buffers);
    }
    readBuffer(src) {
        var _a;
        this.state.READ_BUFFER = src;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.readBuffer(src);
    }
    depthFunc(func) {
        var _a;
        this.state.DEPTH_FUNC = func;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.depthFunc(func);
    }
    depthMask(flag) {
        var _a;
        this.state.DEPTH_WRITEMASK = flag;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.depthMask(flag);
    }
    depthRange(zNear, zFar) {
        var _a;
        this.state.DEPTH_RANGE.set([zNear, zFar]);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.depthRange(zNear, zFar);
    }
    detachShader(program, shader) {
        var _a;
        if (this.programs.has(program) && this.shaders.has(shader)) {
            const mock_program = this.programs.get(program);
            const mock_shader = this.shaders.get(shader);
            const shader_index = mock_program.attached_shaders.indexOf(mock_shader);
            if (shader_index !== -1) {
                mock_program.attached_shaders = mock_program.attached_shaders.splice(shader_index, 1);
            }
            else {
                console.error("Program does not have shader. Can't detach.");
            }
        }
        else {
            console.error('Invalid program or shader');
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.detachShader(program, shader);
    }
    disableVertexAttribArray(index) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.disableVertexAttribArray(index);
    }
    drawArrays(mode, first, count) {
        var _a;
        this.fake_query_data_for_draw(count);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.drawArrays(mode, first, count);
    }
    drawElements(mode, count, type, offset) {
        var _a;
        this.fake_query_data_for_draw(count);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.drawElements(mode, count, type, offset);
    }
    drawRangeElements(mode, start, end, count, type, offset) {
        var _a;
        this.fake_query_data_for_draw(count);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.drawRangeElements(mode, start, end, count, type, offset);
    }
    update_cap(cap, enabled) {
        if (!this.state_field_reverse_lookup_map.has(cap)) {
            console.error('Invalid cap: not found: ' + cap);
            return;
        }
        const v = this.state_field_reverse_lookup_map.get(cap);
        if (typeof this.state[v] !== 'boolean') {
            console.error('Invalid cap: cap is not boolean: ' + cap);
            return;
        }
        this.state[v] = enabled;
    }
    enable(cap) {
        var _a;
        this.update_cap(cap, true);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.enable(cap);
    }
    disable(cap) {
        var _a;
        this.update_cap(cap, false);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.disable(cap);
    }
    isEnabled(cap) {
        let value;
        if (!this.state_field_reverse_lookup_map.has(cap)) {
            console.error('Invalid cap: not found: ' + cap);
            value = false;
        }
        else {
            const v = this.state_field_reverse_lookup_map.get(cap);
            if (typeof this.state[v] !== 'boolean') {
                console.error('Invalid cap: cap is not boolean: ' + cap);
                value = false;
            }
            else {
                value = this.state[v];
            }
        }
        if (this.passthrough) {
            const real_value = this.passthrough.isEnabled(cap);
            if (real_value !== value) {
                console.error('Cap mock mismatch: cap not the same: ' + cap);
                value = real_value;
            }
        }
        return value;
    }
    enableVertexAttribArray(index) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.enableVertexAttribArray(index);
    }
    finish() {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.finish();
    }
    flush() {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.flush();
    }
    framebufferRenderbuffer(target, attachment, renderbuffertarget, renderbuffer) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.framebufferRenderbuffer(target, attachment, renderbuffertarget, renderbuffer);
    }
    framebufferTexture2D(target, attachment, textarget, texture, level) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.framebufferTexture2D(target, attachment, textarget, texture, level);
    }
    framebufferTextureLayer(target, attachment, texture, level, layer) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.framebufferTextureLayer(target, attachment, texture, level, layer);
    }
    invalidateFramebuffer(target, attachments) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.invalidateFramebuffer(target, attachments);
    }
    invalidateSubFramebuffer(target, attachments, x, y, width, height) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.invalidateSubFramebuffer(target, attachments, x, y, width, height);
    }
    frontFace(mode) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.frontFace(mode);
    }
    generateMipmap(target) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.generateMipmap(target);
    }
    getActiveAttrib(program, index) {
        if (this.passthrough === null) {
            // TODO: Figure out what to actually return here.
            // Not used by Babylon.
            return null;
        }
        else {
            return this.passthrough.getActiveAttrib(program, index);
        }
    }
    getActiveUniform(program, index) {
        if (this.passthrough === null) {
            // TODO: Figure out what to actually return here.
            // Not used by Babylon.
            return null;
        }
        else {
            return this.passthrough.getActiveUniform(program, index);
        }
    }
    getAttachedShaders(program) {
        let result;
        if (!this.programs.has(program)) {
            result = null;
        }
        else {
            const mock_programs = this.programs.get(program).attached_shaders;
            result = mock_programs.map((value) => {
                return value.actual_shader;
            });
        }
        if (this.passthrough !== null) {
            // We have an actual context, make sure we are aligned
            const real_shaders = this.passthrough.getAttachedShaders(program);
            let errored = false;
            if ((real_shaders === null && result !== null) || (real_shaders !== null && result === null)) {
                console.error('Program mocking error: Mock & GL implementation have mismatching state: null vs non-null');
                errored = true;
            }
            else if (real_shaders !== null && result !== null) {
                if (real_shaders.length !== result.length) {
                    console.error('Program mocking error: Mock & GL implementation have mismatching state: shader count');
                    errored = true;
                }
                else {
                    // Check that the references are matching up
                    let missing_shaders = 0;
                    real_shaders.forEach((real) => {
                        if (result.indexOf(real) === -1) {
                            missing_shaders++;
                        }
                    });
                    if (missing_shaders > 0) {
                        console.error('Program mocking error: Mock & GL implementation have mismatching state: ' + missing_shaders + ' mismatching shader references');
                        errored = true;
                    }
                }
            }
            if (errored) {
                // Correct result to make sure our runtime is correct.
                result = real_shaders;
            }
        }
        return result;
    }
    getAttribLocation(program, name) {
        let result;
        if (!this.programs.has(program)) {
            console.error('getAttribLocation: Invalid program');
            result = -1;
        }
        else {
            const mock_program = this.programs.get(program);
            if (mock_program.fake_attrib_indices.has(name)) {
                result = mock_program.fake_attrib_indices.get(name);
            }
            else {
                if (this.passthrough === null) {
                    // Create a fake index
                    // TODO: Generate from shader source
                    result = mock_program.fake_attrib_indices.size;
                }
                else {
                    // Fetch the real index
                    result = this.passthrough.getAttribLocation(program, name);
                }
                mock_program.fake_attrib_indices.set(name, result);
            }
        }
        if (this.passthrough !== null) {
            // Verify our state matches the GL state
            const real_result = this.passthrough.getAttribLocation(program, name);
            if (real_result !== result) {
                console.error('Program mocking error: Mock & GL implementation have mismatching attrib locations.');
                // Correct the result to make sure our runtime is correct.
                result = real_result;
            }
        }
        return result;
    }
    getBufferSubData(target, srcByteOffset, dstBuffer, dstOffset, length) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.getBufferSubData(target, srcByteOffset, dstBuffer, dstOffset, length);
    }
    getBufferParameter(target, pname) {
        let result = 0;
        if (this.currently_bound_buffers.has(target)) {
            const real_buffer = this.currently_bound_buffers.get(target);
            if (this.buffers.has(real_buffer)) {
                const buffer = this.buffers.get(real_buffer);
                if (pname === this.BUFFER_SIZE) {
                    result = buffer.buffer_size;
                }
                else if (pname === this.BUFFER_USAGE) {
                    result = buffer.buffer_usage;
                }
                else {
                    console.error('getBufferParameter: Invalid pname: ' + pname);
                }
            }
            else {
                console.error('getBufferParameter: Missing buffer');
            }
        }
        if (this.passthrough) {
            // Make sure we have the same result!
            const real_result = this.passthrough.getBufferParameter(target, pname);
            if (real_result !== result) {
                console.error('getBufferParameter: Mismatching state.');
                // Correct the result to make sure our runtime is correct.
                result = real_result;
            }
        }
        return result;
    }
    getContextAttributes() {
        // TODO: Implement faked data?
        return null;
    }
    getError() {
        if (this.passthrough === null) {
            return this.NO_ERROR;
        }
        else {
            return this.passthrough.getError();
        }
    }
    getFramebufferAttachmentParameter(target, attachment, pname) {
        throw new Error('Not implemented by mock');
    }
    getParameter(pname) {
        if (pname === this.SAMPLER_BINDING) {
            return this.active_samplers[this.state.ACTIVE_TEXTURE - this.TEXTURE0];
        }
        if (pname === this.TRANSFORM_FEEDBACK_PAUSED) {
            console.error("Mock doesn't implement TRANSFORM_FEEDBACK_X state");
            return undefined;
        }
        if (this.state_field_reverse_lookup_map.has(pname)) {
            const field = this.state_field_reverse_lookup_map.get(pname);
            const value = this.state[field];
            return value;
        }
        else if (this.capabilities_field_reverse_lookup_map.has(pname)) {
            const field = this.capabilities_field_reverse_lookup_map.get(pname);
            const value = this.capabilities[field];
            return value;
        }
        else {
            console.error('Missing parameter field lookup for: ' + pname);
        }
    }
    isBuffer(buffer) {
        let result;
        if (buffer === null) {
            result = false;
        }
        else {
            if (this.buffers.has(buffer)) {
                const mock_buffer = this.buffers.get(buffer);
                result = mock_buffer.is_initialized;
            }
            else {
                result = false;
            }
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isBuffer(buffer);
            if (real_result !== result) {
                console.error('Buffer mocking error: Mock & GL implementation have mismatching state: isBuffer yields different values');
                result = real_result;
            }
        }
        return result;
    }
    getProgramInfoLog(program) {
        if (!this.programs.has(program)) {
            console.error('Invalid program!');
        }
        if (this.passthrough === null) {
            return null;
        }
        else {
            return this.passthrough.getProgramInfoLog(program);
        }
    }
    getProgramParameter(program, pname) {
        let result;
        if (pname === this.VALIDATE_STATUS) {
            result = this.programs.get(program).validate_status;
        }
        else if (pname === this.LINK_STATUS) {
            result = this.programs.get(program).link_status;
        }
        else {
            result = null;
            console.error('Invalid enum: ' + pname);
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.getProgramParameter(program, pname);
            if (real_result !== result) {
                console.error('Mocking error: results mismatch!');
                result = real_result;
            }
        }
        return result;
    }
    getRenderbufferParameter(target, pname) {
        throw new Error('Not implemented by mock');
    }
    getShaderInfoLog(shader) {
        return null;
    }
    getShaderParameter(shader, pname) {
        if (pname === this.COMPILE_STATUS) {
            return true;
        }
        else if (pname === this.SHADER_TYPE) {
            return this.shaders.get(shader).type;
        }
        throw new Error('Case not implemented.');
    }
    getShaderPrecisionFormat(shadertype, precisiontype) {
        if (precisiontype === this.LOW_FLOAT || precisiontype === this.MEDIUM_FLOAT || precisiontype === this.HIGH_FLOAT) {
            // https://developer.mozilla.org/en-US/docs/Web/API/WebGLShaderPrecisionFormat
            // Lets just return floats all the way around. This is what my M2 mac gives
            return {
                rangeMin: 127,
                rangeMax: 127,
                precision: 23
            };
        }
        else if (precisiontype === this.LOW_INT || precisiontype === this.MEDIUM_INT || precisiontype === this.HIGH_INT) {
            return {
                rangeMin: 31,
                rangeMax: 30,
                precision: 0
            };
        }
        else {
            console.error('Invalid shader precision format precisionType');
            return null;
        }
    }
    getShaderSource(shader) {
        return this.shaders.get(shader).source;
    }
    set_tex_parameter_internal(target, pname, param) {
        if (!this.currently_bound_textures.has(target)) {
            console.error('No texture bound to target: ' + target);
        }
        else {
            const tex = this.textures.get(this.currently_bound_textures.get(target));
            if (!this.set_sampler_configuration_parameter(tex.sampler_configuration, pname, param)) {
                // It wasn't a sampler parameter, check for texture parameters
                if (pname === this.TEXTURE_MAX_LEVEL) {
                    tex.max_level = param;
                }
                else if (pname === this.TEXTURE_BASE_LEVEL) {
                    tex.base_level = param;
                }
                else {
                    console.error('Invalid texture parameter: ' + pname);
                }
            }
        }
    }
    /**
     * Sets the parameter of pname on sampler_configuration.
     * @returns Returns true if the parameter was set, false if it was an invalid parameter
     */
    set_sampler_configuration_parameter(sampler_configuration, pname, value) {
        if (pname === this.TEXTURE_MIN_FILTER) {
            sampler_configuration.min_filter = value;
        }
        else if (pname === this.TEXTURE_MAG_FILTER) {
            sampler_configuration.mag_filter = value;
        }
        else if (pname === this.TEXTURE_WRAP_S) {
            sampler_configuration.wrap_s = value;
        }
        else if (pname === this.TEXTURE_WRAP_T) {
            sampler_configuration.wrap_t = value;
        }
        else if (pname === this.TEXTURE_WRAP_R) {
            sampler_configuration.wrap_r = value;
        }
        else if (pname === this.TEXTURE_MIN_LOD) {
            sampler_configuration.min_lod = value;
        }
        else if (pname === this.TEXTURE_MAX_LOD) {
            sampler_configuration.max_lod = value;
        }
        else if (pname === this.TEXTURE_COMPARE_FUNC) {
            sampler_configuration.compare_func = value;
        }
        else if (pname === this.TEXTURE_COMPARE_MODE) {
            sampler_configuration.compare_mode = value;
        }
        else {
            return false;
        }
        return true;
    }
    get_sampler_configuration_parameter(sampler_configuration, pname) {
        if (pname === this.TEXTURE_MIN_FILTER) {
            return sampler_configuration.min_filter;
        }
        else if (pname === this.TEXTURE_MAG_FILTER) {
            return sampler_configuration.mag_filter;
        }
        else if (pname === this.TEXTURE_WRAP_S) {
            return sampler_configuration.wrap_s;
        }
        else if (pname === this.TEXTURE_WRAP_T) {
            return sampler_configuration.wrap_t;
        }
        else if (pname === this.TEXTURE_WRAP_R) {
            return sampler_configuration.wrap_r;
        }
        else if (pname === this.TEXTURE_MIN_LOD) {
            return sampler_configuration.min_lod;
        }
        else if (pname === this.TEXTURE_MAX_LOD) {
            return sampler_configuration.max_lod;
        }
        else if (pname === this.TEXTURE_COMPARE_FUNC) {
            return sampler_configuration.compare_func;
        }
        else if (pname === this.TEXTURE_COMPARE_MODE) {
            return sampler_configuration.compare_mode;
        }
        else {
            return null;
        }
    }
    getTexParameter(target, pname) {
        let result;
        if (!this.currently_bound_textures.get(target)) {
            console.error('No texture bound to target: ' + target);
            result = null;
        }
        else {
            const tex = this.textures.get(this.currently_bound_textures.get(target));
            result = this.get_sampler_configuration_parameter(tex.sampler_configuration, pname);
            if (result === null) {
                // It wasn't a sampler parameter, check for texture parameters
                if (pname === this.TEXTURE_IMMUTABLE_FORMAT) {
                    result = tex.immutable_format;
                }
                else if (pname === this.TEXTURE_IMMUTABLE_LEVELS) {
                    result = tex.immutable_levels;
                }
                else if (pname === this.TEXTURE_MAX_LEVEL) {
                    result = tex.max_level;
                }
                else if (pname === this.TEXTURE_BASE_LEVEL) {
                    result = tex.base_level;
                }
            }
        }
        if (this.passthrough !== null) {
            // Verify our results are matching
            const val = this.passthrough.getTexParameter(target, pname);
            if (val !== result) {
                console.error('WebGL Texture mocking error! Mismatching state. target: ' + target + ', pname: ' + pname);
                // Correct the results for good runtime
                result = val;
            }
        }
        return result;
    }
    getUniform(program, location) {
        if (this.passthrough === null) {
            return null;
        }
        else {
            return this.passthrough.getUniform(program, location);
        }
    }
    getUniformLocation(program, name) {
        let result;
        if (!this.programs.has(program)) {
            console.error('getUniformLocation: Invalid program');
            result = null;
        }
        else {
            const mock_program = this.programs.get(program);
            if (this.passthrough === null) {
                if (mock_program.fake_uniform_indices.has(name)) {
                    // Create a fake index
                    // TODO: Generate from shader source
                    const fake_location = {
                        _currentState: mock_program.fake_uniform_indices.size
                    };
                    result = fake_location;
                }
                else {
                    result = mock_program.fake_uniform_indices.get(name);
                }
            }
            else {
                // Fetch the real index
                result = this.passthrough.getUniformLocation(program, name);
            }
            mock_program.fake_uniform_indices.set(name, result);
        }
        return result;
    }
    getUniformIndices(program, uniformNames) {
        if (this.passthrough === null) {
            if (!this.programs.has(program))
                return null;
            const mock_program = this.programs.get(program);
            const result = uniformNames.map((uniformName) => {
                var _a, _b;
                return (_b = (_a = mock_program.fake_uniform_indices.get(uniformName)) === null || _a === void 0 ? void 0 : _a._currentState) !== null && _b !== void 0 ? _b : -1;
            });
            return result;
        }
        else {
            return this.passthrough.getUniformIndices(program, uniformNames);
        }
    }
    getActiveUniformBlockName(program, uniformBlockIndex) {
        var _a;
        if (this.passthrough === null) {
            const mock_program = this.programs.get(program);
            // See if we have the index already
            let found_name = null;
            mock_program.fake_uniform_block_indices.forEach((value, key) => {
                if (value === uniformBlockIndex) {
                    found_name = key;
                }
            });
            if (found_name !== null) {
                return found_name;
            }
            const fake_name = 'fake_generated_mock_name_' + uniformBlockIndex.toString();
            mock_program.fake_uniform_block_indices.set(fake_name, uniformBlockIndex);
            return fake_name;
        }
        else {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.getActiveUniformBlockName(program, uniformBlockIndex);
        }
    }
    getUniformBlockIndex(program, uniformBlockName) {
        if (this.passthrough === null) {
            const mock_program = this.programs.get(program);
            if (mock_program.fake_uniform_block_indices.has(uniformBlockName)) {
                return mock_program.fake_uniform_block_indices.get(uniformBlockName);
            }
            else {
                const fake_index = mock_program.fake_uniform_block_indices.size;
                mock_program.fake_uniform_block_indices.set(uniformBlockName, fake_index);
                return fake_index;
            }
        }
        else {
            return this.passthrough.getUniformBlockIndex(program, uniformBlockName);
        }
    }
    getActiveUniformBlockParameter(program, uniformBlockIndex, pname) {
        if (this.passthrough === null) {
            const fake_uniform_count = 8;
            if (pname === this.UNIFORM_BLOCK_BINDING) {
                return uniformBlockIndex;
            }
            else if (pname === this.UNIFORM_BLOCK_DATA_SIZE) {
                return fake_uniform_count * 16;
            }
            else if (pname === this.UNIFORM_BLOCK_ACTIVE_UNIFORMS) {
                return fake_uniform_count;
            }
            else if (pname === this.UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES) {
                const indices = new Uint32Array(fake_uniform_count);
                for (let i = 0; i < fake_uniform_count; i++) {
                    indices[i] = i;
                }
                return indices;
            }
            else if (pname === this.UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER) {
                return true;
            }
            else if (pname === this.UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER) {
                return true;
            }
            else {
                console.error('Invalid pname');
                return null;
            }
        }
        else {
            return this.passthrough.getActiveUniformBlockParameter(program, uniformBlockIndex, pname);
        }
    }
    getActiveUniforms(program, uniformIndices, pname) {
        throw new Error('Not implemented by mock');
    }
    getVertexAttrib(index, pname) {
        throw new Error('Not implemented by mock');
    }
    getVertexAttribOffset(index, pname) {
        throw new Error('Not implemented by mock');
    }
    hint(target, mode) {
        var _a;
        if (target === this.GENERATE_MIPMAP_HINT) {
            this.state.GENERATE_MIPMAP_HINT = mode;
        }
        else if (target === this.FRAGMENT_SHADER_DERIVATIVE_HINT) {
            this.state.FRAGMENT_SHADER_DERIVATIVE_HINT = mode;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.hint(target, mode);
    }
    isContextLost() {
        return false;
    }
    isFramebuffer(framebuffer) {
        let result;
        if (framebuffer === null) {
            result = false;
        }
        else if (this.framebuffers.has(framebuffer)) {
            result = this.framebuffers.get(framebuffer).is_framebuffer;
        }
        else {
            result = false;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isFramebuffer(framebuffer);
            if (real_result !== result) {
                console.error('WebGL mock error: isFramebuffer results differ between implementation and mock.');
                result = real_result;
            }
        }
        return result;
    }
    isProgram(program) {
        let result;
        if (program === null) {
            result = false;
        }
        else if (this.programs.has(program)) {
            result = this.programs.get(program).is_program;
        }
        else {
            result = false;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isProgram(program);
            if (real_result !== result) {
                console.error('WebGL mock error: isRenderbuffer results differ between implementation and mock.');
                result = real_result;
            }
        }
        return result;
    }
    isRenderbuffer(renderbuffer) {
        let result;
        if (renderbuffer === null) {
            result = false;
        }
        else if (this.renderbuffers.has(renderbuffer)) {
            result = this.renderbuffers.get(renderbuffer).is_renderbuffer;
        }
        else {
            result = false;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isRenderbuffer(renderbuffer);
            if (real_result !== result) {
                console.error('WebGL mock error: isRenderbuffer results differ between implementation and mock.');
                result = real_result;
            }
        }
        return result;
    }
    isShader(shader) {
        let result;
        if (shader === null) {
            result = false;
        }
        else {
            result = this.shaders.has(shader);
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isShader(shader);
            if (real_result !== result) {
                console.error('WebGL mock error: isShader results differ between implementation and mock.');
                result = real_result;
            }
        }
        return result;
    }
    isTexture(texture) {
        let result;
        if (texture === null) {
            result = false;
        }
        else if (this.textures.has(texture)) {
            result = this.textures.get(texture).is_texture;
        }
        else {
            result = false;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isTexture(texture);
            if (real_result !== result) {
                console.error('WebGL mock error: isTexture results differ between implementation and mock.');
                result = real_result;
            }
        }
        return result;
    }
    lineWidth(width) {
        var _a;
        this.state.LINE_WIDTH = Math.min(this.capabilities.ALIASED_POINT_SIZE_RANGE.at(1), Math.max(this.capabilities.ALIASED_POINT_SIZE_RANGE.at(0), width));
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.lineWidth(width);
    }
    linkProgram(program) {
        if (this.passthrough === null) {
            this.programs.get(program).is_program = true;
            this.programs.get(program).link_status = true;
        }
        else {
            this.passthrough.linkProgram(program);
            this.programs.get(program).is_program = this.passthrough.isProgram(program);
            this.programs.get(program).link_status = this.passthrough.getProgramParameter(program, this.passthrough.LINK_STATUS);
        }
    }
    pixelStorei(pname, param) {
        var _a;
        const bool_value = typeof param === 'boolean' ? param : (!!param);
        if (pname === this.UNPACK_FLIP_Y_WEBGL) {
            this.state.UNPACK_FLIP_Y_WEBGL = bool_value;
        }
        else if (pname === this.UNPACK_PREMULTIPLY_ALPHA_WEBGL) {
            this.state.UNPACK_PREMULTIPLY_ALPHA_WEBGL = bool_value;
        }
        if (typeof param === 'number') {
            if (pname === this.PACK_ALIGNMENT) {
                this.state.PACK_ALIGNMENT = param;
            }
            else if (pname === this.UNPACK_ALIGNMENT) {
                this.state.UNPACK_ALIGNMENT = param;
            }
            else if (pname === this.UNPACK_COLORSPACE_CONVERSION_WEBGL) {
                this.state.UNPACK_COLORSPACE_CONVERSION_WEBGL = param;
            }
            else if (pname === this.PACK_ROW_LENGTH) {
                this.state.PACK_ROW_LENGTH = param;
            }
            else if (pname === this.PACK_SKIP_PIXELS) {
                this.state.PACK_SKIP_PIXELS = param;
            }
            else if (pname === this.PACK_SKIP_ROWS) {
                this.state.PACK_SKIP_ROWS = param;
            }
            else if (pname === this.UNPACK_ROW_LENGTH) {
                this.state.UNPACK_ROW_LENGTH = param;
            }
            else if (pname === this.UNPACK_IMAGE_HEIGHT) {
                this.state.UNPACK_IMAGE_HEIGHT = param;
            }
            else if (pname === this.UNPACK_SKIP_PIXELS) {
                this.state.UNPACK_SKIP_PIXELS = param;
            }
            else if (pname === this.UNPACK_SKIP_ROWS) {
                this.state.UNPACK_SKIP_ROWS = param;
            }
            else if (pname === this.UNPACK_SKIP_IMAGES) {
                this.state.UNPACK_SKIP_IMAGES = param;
            }
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.pixelStorei(pname, param);
    }
    polygonOffset(factor, units) {
        var _a;
        this.state.POLYGON_OFFSET_FACTOR = factor;
        this.state.POLYGON_OFFSET_UNITS = units;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.polygonOffset(factor, units);
    }
    renderbufferStorage(target, internalformat, width, height) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.renderbufferStorage(target, internalformat, width, height);
    }
    renderbufferStorageMultisample(target, samples, internalformat, width, height) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.renderbufferStorageMultisample(target, samples, internalformat, width, height);
    }
    sampleCoverage(value, invert) {
        var _a;
        this.state.SAMPLE_COVERAGE_VALUE = value;
        this.state.SAMPLE_COVERAGE_INVERT = invert;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.sampleCoverage(value, invert);
    }
    scissor(x, y, width, height) {
        var _a;
        this.state.SCISSOR_BOX.set([x, y, width, height]);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.scissor(x, y, width, height);
    }
    shaderSource(shader, source) {
        var _a;
        this.shaders.get(shader).source = source;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.shaderSource(shader, source);
    }
    stencilFunc(func, ref, mask) {
        var _a;
        this.state.STENCIL_FUNC = func;
        this.state.STENCIL_REF = ref;
        this.state.STENCIL_VALUE_MASK = mask;
        this.state.STENCIL_BACK_FUNC = func;
        this.state.STENCIL_BACK_REF = ref;
        this.state.STENCIL_BACK_VALUE_MASK = mask;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.stencilFunc(func, ref, mask);
    }
    stencilFuncSeparate(face, func, ref, mask) {
        var _a;
        if (face === this.FRONT || face === this.FRONT_AND_BACK) {
            this.state.STENCIL_FUNC = func;
            this.state.STENCIL_REF = ref;
            this.state.STENCIL_VALUE_MASK = mask;
        }
        if (face === this.BACK || face === this.FRONT_AND_BACK) {
            this.state.STENCIL_BACK_FUNC = func;
            this.state.STENCIL_BACK_REF = ref;
            this.state.STENCIL_BACK_VALUE_MASK = mask;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.stencilFuncSeparate(face, func, ref, mask);
    }
    stencilMask(mask) {
        var _a;
        this.state.STENCIL_WRITEMASK = mask;
        this.state.STENCIL_BACK_WRITEMASK = mask;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.stencilMask(mask);
    }
    stencilMaskSeparate(face, mask) {
        var _a;
        if (face === this.FRONT || face === this.FRONT_AND_BACK) {
            this.state.STENCIL_WRITEMASK = mask;
        }
        if (face === this.BACK || face === this.FRONT_AND_BACK) {
            this.state.STENCIL_BACK_WRITEMASK = mask;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.stencilMask(mask);
    }
    stencilOp(fail, zfail, zpass) {
        var _a;
        this.state.STENCIL_FAIL = fail;
        this.state.STENCIL_BACK_FAIL = fail;
        this.state.STENCIL_PASS_DEPTH_FAIL = zfail;
        this.state.STENCIL_BACK_PASS_DEPTH_FAIL = zfail;
        this.state.STENCIL_PASS_DEPTH_PASS = zpass;
        this.state.STENCIL_BACK_PASS_DEPTH_PASS = zpass;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.stencilOp(fail, zfail, zpass);
    }
    stencilOpSeparate(face, fail, zfail, zpass) {
        var _a;
        if (face === this.FRONT || face === this.FRONT_AND_BACK) {
            this.state.STENCIL_FAIL = fail;
            this.state.STENCIL_PASS_DEPTH_FAIL = zfail;
            this.state.STENCIL_PASS_DEPTH_PASS = zpass;
        }
        if (face === this.BACK || face === this.FRONT_AND_BACK) {
            this.state.STENCIL_BACK_FAIL = fail;
            this.state.STENCIL_BACK_PASS_DEPTH_FAIL = zfail;
            this.state.STENCIL_BACK_PASS_DEPTH_PASS = zpass;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.stencilOpSeparate(face, fail, zfail, zpass);
    }
    texStorage2D(target, levels, internalformat, width, height) {
        var _a;
        if (this.currently_bound_textures.has(target) || this.currently_bound_textures.get(target) === null) {
            console.error('no texture bound to target: ' + target);
        }
        else if (!this.textures.has(this.currently_bound_textures.get(target))) {
            console.error('mock error, missing texture');
        }
        else {
            const texture = this.currently_bound_textures.get(target);
            const mock_texture = this.textures.get(texture);
            mock_texture.immutable_format = true;
            mock_texture.immutable_levels = levels;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texStorage2D(target, levels, internalformat, width, height);
    }
    texStorage3D(target, levels, internalformat, width, height, depth) {
        var _a;
        if (this.currently_bound_textures.has(target) || this.currently_bound_textures.get(target) === null) {
            console.error('no texture bound to target: ' + target);
        }
        else if (!this.textures.has(this.currently_bound_textures.get(target))) {
            console.error('mock error, missing texture');
        }
        else {
            const texture = this.currently_bound_textures.get(target);
            const mock_texture = this.textures.get(texture);
            mock_texture.immutable_format = true;
            mock_texture.immutable_levels = levels;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texStorage3D(target, levels, internalformat, width, height, depth);
    }
    texImage2D(target, level, internalformat, width_format, height_type, border_source, format, type, pboOffset_source_pixels, srcOffset) {
        var _a, _b, _c, _d;
        if (typeof border_source === 'number') {
            if (format === undefined || type === undefined || pboOffset_source_pixels === undefined) {
                console.error('Invalid mock overload implementation');
            }
            else if (srcOffset === undefined) {
                if (typeof pboOffset_source_pixels === 'number') {
                    console.error('Invalid mock overload implementation');
                }
                else if (pboOffset_source_pixels !== undefined) {
                    if (pboOffset_source_pixels === null) {
                        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texImage2D(target, level, internalformat, width_format, height_type, border_source, format, type, null);
                    }
                    else {
                        // Here we have to cast as any because Typescript doesn't understand
                        return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.texImage2D(target, level, internalformat, width_format, height_type, border_source, format, type, pboOffset_source_pixels);
                    }
                }
            }
            else {
                if (pboOffset_source_pixels === null) {
                    console.error('Invalid mock overload implementation');
                }
                return (_c = this.passthrough) === null || _c === void 0 ? void 0 : _c.texImage2D(target, level, internalformat, width_format, height_type, border_source, format, type, pboOffset_source_pixels, srcOffset);
            }
        }
        else {
            return (_d = this.passthrough) === null || _d === void 0 ? void 0 : _d.texImage2D(target, level, internalformat, width_format, height_type, border_source);
        }
    }
    texSubImage2D(target, level, xoffset, yoffset, width_format, height_type, format_source, type, source_srcData_pboOffset_pixels, srcOffset) {
        var _a, _b, _c, _d;
        if (typeof format_source !== 'number') {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texSubImage2D(target, level, xoffset, yoffset, width_format, height_type, format_source);
        }
        else {
            if (type === undefined) {
                console.error('Invalid mock overload implementation');
            }
            else if (srcOffset !== undefined) {
                if (source_srcData_pboOffset_pixels === null) {
                    console.error('Invalid mock overload implementation');
                }
                return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.texSubImage2D(target, level, xoffset, yoffset, width_format, height_type, format_source, type, source_srcData_pboOffset_pixels, srcOffset);
            }
            else if (typeof source_srcData_pboOffset_pixels === 'number') {
                return (_c = this.passthrough) === null || _c === void 0 ? void 0 : _c.texSubImage2D(target, level, xoffset, yoffset, width_format, height_type, format_source, type, source_srcData_pboOffset_pixels);
            }
            else {
                // Here we have to cast as any because Typescript doesn't understand
                return (_d = this.passthrough) === null || _d === void 0 ? void 0 : _d.texSubImage2D(target, level, xoffset, yoffset, width_format, height_type, format_source, type, source_srcData_pboOffset_pixels);
            }
        }
    }
    texImage3D(target, level, internalformat, width, height, depth, border, format, type, srcData, srcOffset) {
        var _a, _b;
        if (srcOffset !== undefined) {
            if (typeof srcData === 'number') {
                console.error('Invalid mock overload implementation');
            }
            else if (srcData === null) {
                console.error('Invalid mock overload implementation');
            }
            else {
                return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texImage3D(target, level, internalformat, width, height, depth, border, format, type, srcData, srcOffset);
            }
        }
        else {
            // Here we have to cast as any because Typescript doesn't understand
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.texImage3D(target, level, internalformat, width, height, depth, border, format, type, srcData);
        }
    }
    texSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, type, srcData, srcOffset) {
        var _a, _b;
        if (srcOffset !== undefined) {
            if (typeof srcData === 'number') {
                console.error('Invalid mock overload implementation');
            }
            else {
                return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, type, srcData, srcOffset);
            }
        }
        else {
            // Here we have to cast as any because Typescript doesn't understand
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.texSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, type, srcData);
        }
    }
    texParameterf(target, pname, param) {
        var _a;
        this.set_tex_parameter_internal(target, pname, param);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texParameterf(target, pname, param);
    }
    texParameteri(target, pname, param) {
        var _a;
        this.set_tex_parameter_internal(target, pname, param);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.texParameteri(target, pname, param);
    }
    uniform1f(location, x) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform1f(location, x);
    }
    uniform1fv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform1fv(location, v, srcOffset, srcLength);
    }
    uniform1i(location, x) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform1i(location, x);
    }
    uniform1iv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform1iv(location, v, srcOffset, srcLength);
    }
    uniform2f(location, x, y) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform2f(location, x, y);
    }
    uniform2fv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform2fv(location, v, srcOffset, srcLength);
    }
    uniform2i(location, x, y) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform2i(location, x, y);
    }
    uniform2iv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform2iv(location, v, srcOffset, srcLength);
    }
    uniform3f(location, x, y, z) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform3f(location, x, y, z);
    }
    uniform3fv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform3fv(location, v, srcOffset, srcLength);
    }
    uniform3i(location, x, y, z) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform3i(location, x, y, z);
    }
    uniform3iv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform3iv(location, v, srcOffset, srcLength);
    }
    uniform4f(location, x, y, z, w) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform4f(location, x, y, z, w);
    }
    uniform4fv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform4fv(location, v, srcOffset, srcLength);
    }
    uniform4i(location, x, y, z, w) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform4i(location, x, y, z, w);
    }
    uniform4iv(location, v, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform4iv(location, v, srcOffset, srcLength);
    }
    uniformMatrix2fv(location, transpose, value, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix2fv(location, transpose, value, srcOffset, srcLength);
    }
    uniformMatrix3fv(location, transpose, value, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix3fv(location, transpose, value, srcOffset, srcLength);
    }
    uniformMatrix4fv(location, transpose, value, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix4fv(location, transpose, value, srcOffset, srcLength);
    }
    uniform1ui(location, v0) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform1ui(location, v0);
    }
    uniform1uiv(location, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform1uiv(location, data, srcOffset, srcLength);
    }
    uniform2ui(location, v0, v1) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform2ui(location, v0, v1);
    }
    uniform2uiv(location, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform2uiv(location, data, srcOffset, srcLength);
    }
    uniform3ui(location, v0, v1, v2) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform3ui(location, v0, v1, v2);
    }
    uniform3uiv(location, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform3uiv(location, data, srcOffset, srcLength);
    }
    uniform4ui(location, v0, v1, v2, v3) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform4ui(location, v0, v1, v2, v3);
    }
    uniform4uiv(location, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniform4uiv(location, data, srcOffset, srcLength);
    }
    uniformBlockBinding(program, uniformBlockIndex, uniformBlockBinding) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformBlockBinding(program, uniformBlockIndex, uniformBlockBinding);
    }
    uniformMatrix2x3fv(location, transpose, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix2x3fv(location, transpose, data, srcOffset, srcLength);
    }
    uniformMatrix2x4fv(location, transpose, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix2x4fv(location, transpose, data, srcOffset, srcLength);
    }
    uniformMatrix3x2fv(location, transpose, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix3x2fv(location, transpose, data, srcOffset, srcLength);
    }
    uniformMatrix3x4fv(location, transpose, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix3x4fv(location, transpose, data, srcOffset, srcLength);
    }
    uniformMatrix4x2fv(location, transpose, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix4x2fv(location, transpose, data, srcOffset, srcLength);
    }
    uniformMatrix4x3fv(location, transpose, data, srcOffset, srcLength) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.uniformMatrix4x3fv(location, transpose, data, srcOffset, srcLength);
    }
    useProgram(program) {
        var _a;
        this.state.CURRENT_PROGRAM = program;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.useProgram(program);
    }
    validateProgram(program) {
        if (this.passthrough === null) {
            this.programs.get(program).validate_status = true;
        }
        else {
            this.passthrough.validateProgram(program);
            this.programs.get(program).validate_status = !!this.passthrough.getProgramParameter(program, this.passthrough.VALIDATE_STATUS);
        }
    }
    vertexAttrib1f(index, x) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib1f(index, x);
    }
    vertexAttrib1fv(index, values) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib1fv(index, values);
    }
    vertexAttrib2f(index, x, y) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib2f(index, x, y);
    }
    vertexAttrib2fv(index, values) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib2fv(index, values);
    }
    vertexAttrib3f(index, x, y, z) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib3f(index, x, y, z);
    }
    vertexAttrib3fv(index, values) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib3fv(index, values);
    }
    vertexAttrib4f(index, x, y, z, w) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib4f(index, x, y, z, w);
    }
    vertexAttrib4fv(index, values) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttrib4fv(index, values);
    }
    vertexAttribPointer(index, size, type, normalized, stride, offset) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    vertexAttribI4i(index, x, y, z, w) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttribI4i(index, x, y, z, w);
    }
    vertexAttribI4iv(index, values) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttribI4iv(index, values);
    }
    vertexAttribI4ui(index, x, y, z, w) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttribI4ui(index, x, y, z, w);
    }
    vertexAttribI4uiv(index, values) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttribI4uiv(index, values);
    }
    vertexAttribIPointer(index, size, type, stride, offset) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttribIPointer(index, size, type, stride, offset);
    }
    viewport(x, y, width, height) {
        var _a;
        this.state.VIEWPORT.set([x, y, width, height]);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.viewport(x, y, width, height);
    }
    readPixels(x, y, width, height, format, type, dstData, dstOffset) {
        var _a, _b, _c;
        if (dstOffset !== undefined) {
            if (dstData === null || typeof dstData === 'number') {
                console.error('Invalid mock overload implementation');
            }
            else {
                return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.readPixels(x, y, width, height, format, type, dstData, dstOffset);
            }
        }
        else if (typeof dstData === 'number') {
            return (_b = this.passthrough) === null || _b === void 0 ? void 0 : _b.readPixels(x, y, width, height, format, type, dstData);
        }
        else {
            return (_c = this.passthrough) === null || _c === void 0 ? void 0 : _c.readPixels(x, y, width, height, format, type, dstData);
        }
    }
    // WebGL 2
    /**
     * Progress checklist:
     *  - Implement queries - check
     *  - Implement samplers - check
     *  - Implement transform feedback - check
     *  - Implement sync - check
     *  - Implement VAO - check
     *  - Add missing forwarding functions
     */
    drawArraysInstanced(mode, first, count, instanceCount) {
        var _a;
        this.fake_query_data_for_draw(count * instanceCount);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.drawArraysInstanced(mode, first, count, instanceCount);
    }
    drawElementsInstanced(mode, count, type, offset, instanceCount) {
        var _a;
        this.fake_query_data_for_draw(count * instanceCount);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.drawElementsInstanced(mode, count, type, offset, instanceCount);
    }
    vertexAttribDivisor(index, divisor) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.vertexAttribDivisor(index, divisor);
    }
    createQuery() {
        let query;
        if (this.passthrough === null) {
            query = {};
        }
        else {
            query = this.passthrough.createQuery();
        }
        if (query === null)
            return null;
        this.queries.set(query, {
            actual_query: query,
            target: null,
            value: 0,
            is_query: false
        });
        return query;
    }
    deleteQuery(query) {
        var _a;
        if (query !== null) {
            if (this.current_query_any_samples_passed === query)
                this.current_query_any_samples_passed = null;
            if (this.current_query_any_samples_passed_conservative === query)
                this.current_query_any_samples_passed_conservative = null;
            if (this.current_query_transform_feedback_primitives_written === query)
                this.current_query_transform_feedback_primitives_written = null;
            this.queries.delete(query);
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteQuery(query);
    }
    beginQuery(target, query) {
        var _a;
        // TODO: Make sure ANY_SAMPLES_PASSED and ANY_SAMPLES_PASSED_CONSERVATIVE can't run simultaneously
        if (target === this.ANY_SAMPLES_PASSED) {
            this.current_query_any_samples_passed = query;
        }
        else if (target === this.ANY_SAMPLES_PASSED_CONSERVATIVE) {
            this.current_query_any_samples_passed_conservative = query;
        }
        else if (target === this.TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN) {
            this.current_query_transform_feedback_primitives_written = query;
        }
        else {
            console.error('Invalid query target!');
        }
        this.queries.get(query).target = target;
        this.queries.get(query).value = 0;
        this.queries.get(query).is_query = true;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.beginQuery(target, query);
    }
    endQuery(target) {
        var _a;
        if (target === this.ANY_SAMPLES_PASSED) {
            this.current_query_any_samples_passed = null;
        }
        else if (target === this.ANY_SAMPLES_PASSED_CONSERVATIVE) {
            this.current_query_any_samples_passed_conservative = null;
        }
        else if (target === this.TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN) {
            this.current_query_transform_feedback_primitives_written = null;
        }
        else {
            console.error('Invalid query target!');
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.endQuery(target);
    }
    getQuery(target, pname) {
        if (pname !== this.CURRENT_QUERY) {
            console.error('Invalid pname: ' + pname);
        }
        let result;
        if (target === this.ANY_SAMPLES_PASSED) {
            result = this.current_query_any_samples_passed;
        }
        else if (target === this.ANY_SAMPLES_PASSED_CONSERVATIVE) {
            result = this.current_query_any_samples_passed_conservative;
        }
        else if (target === this.TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN) {
            result = this.current_query_transform_feedback_primitives_written;
        }
        else {
            console.error('Invalid query target!');
            result = null;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.getQuery(target, pname);
            if (real_result !== result) {
                console.error('Mocking error: mismatching queries for target: ' + target);
                result = real_result;
            }
        }
        return result;
    }
    getQueryParameter(query, pname) {
        if (this.passthrough === null) {
            const our_query = this.queries.get(query);
            if (pname === this.QUERY_RESULT_AVAILABLE) {
                return our_query.is_query;
            }
            else if (pname === this.QUERY_RESULT) {
                return our_query.value;
            }
            else {
                console.error('Invalid query parameter');
            }
        }
        else {
            return this.passthrough.getQueryParameter(query, pname);
        }
    }
    isQuery(query) {
        let result;
        if (query === null || !this.queries.has(query)) {
            result = false;
        }
        else {
            result = this.queries.get(query).is_query;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isQuery(query);
            if (real_result !== result) {
                console.error('Mock error! Mismatching between state.');
                result = real_result;
            }
        }
        return result;
    }
    createSampler() {
        let sampler;
        if (this.passthrough === null) {
            sampler = {};
        }
        else {
            sampler = this.passthrough.createSampler();
        }
        if (sampler === null)
            return null;
        this.samplers.set(sampler, {
            actual_sampler: sampler,
            sampler_configuration: Object.assign({}, this.default_sampler_configuration)
        });
        return sampler;
    }
    deleteSampler(sampler) {
        var _a;
        if (sampler !== null) {
            this.samplers.delete(sampler);
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteSampler(sampler);
    }
    isSampler(sampler) {
        let result = sampler === null ? false : this.samplers.has(sampler);
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isSampler(sampler);
            if (real_result !== result) {
                console.error('Mocking error: mismatching state');
                result = real_result;
            }
        }
        return result;
    }
    bindSampler(unit, sampler) {
        var _a;
        this.active_samplers[unit] = sampler;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindSampler(unit, sampler);
    }
    getSamplerParameter(sampler, pname) {
        let result;
        if (this.samplers.has(sampler)) {
            result = this.get_sampler_configuration_parameter(this.samplers.get(sampler).sampler_configuration, pname);
        }
        else {
            result = null;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.getSamplerParameter(sampler, pname);
            if (real_result !== result) {
                console.error('Mock error: mismatching state');
                result = real_result;
            }
        }
        return result;
    }
    samplerParameterf(sampler, pname, param) {
        var _a;
        if (!this.samplers.has(sampler)) {
            console.error('Invalid sampler object');
        }
        else {
            this.set_sampler_configuration_parameter(this.samplers.get(sampler).sampler_configuration, pname, param);
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.samplerParameterf(sampler, pname, param);
    }
    samplerParameteri(sampler, pname, param) {
        var _a;
        if (!this.samplers.has(sampler)) {
            console.error('Invalid sampler object');
        }
        else {
            this.set_sampler_configuration_parameter(this.samplers.get(sampler).sampler_configuration, pname, param);
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.samplerParameteri(sampler, pname, param);
    }
    createTransformFeedback() {
        let tf;
        if (this.passthrough === null) {
            tf = {};
        }
        else {
            tf = this.passthrough.createTransformFeedback();
        }
        if (tf === null)
            return null;
        this.transform_feedbacks.set(tf, {
            actual_tf: tf,
            is_tf: false,
            varyings: new Map()
        });
        return tf;
    }
    deleteTransformFeedback(tf) {
        if (tf !== null) {
            this.transform_feedbacks.delete(tf);
            if (tf === this.state.TRANSFORM_FEEDBACK_BINDING) {
                this.state.TRANSFORM_FEEDBACK_BINDING = null;
            }
        }
    }
    beginTransformFeedback(primitiveMode) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.beginTransformFeedback(primitiveMode);
    }
    endTransformFeedback() {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.endTransformFeedback();
    }
    isTransformFeedback(tf) {
        let result;
        if (tf === null || !this.transform_feedbacks.has(tf)) {
            result = false;
        }
        else {
            result = this.transform_feedbacks.get(tf).is_tf;
        }
        if (this.passthrough !== null) {
            const real_result = this.passthrough.isTransformFeedback(tf);
            if (real_result !== result) {
                console.error('Mock error: mismatching state');
                result = real_result;
            }
        }
        return result;
    }
    bindTransformFeedback(target, tf) {
        var _a;
        if (target === this.TRANSFORM_FEEDBACK) {
            this.state.TRANSFORM_FEEDBACK_BINDING = tf;
            if (tf !== null) {
                this.transform_feedbacks.get(tf).is_tf = true;
            }
        }
        else {
            console.error('Invalid target for bindTransformFeedback. Must be TRANSFORM_FEEDBACK');
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindTransformFeedback(target, tf);
    }
    transformFeedbackVaryings(program, varyings, bufferMode) {
        var _a;
        const program_state = {
            varyings: [...varyings],
            buffer_mode: bufferMode
        };
        this.transform_feedbacks.get(program).varyings.set(program, program_state);
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.transformFeedbackVaryings(program, varyings, bufferMode);
    }
    getTransformFeedbackVarying(program, index) {
        var _a;
        if (this.passthrough === null) {
            console.error('getTransformFeedbackVarying is not implemented by mock.');
            return null;
        }
        else {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.getTransformFeedbackVarying(program, index);
        }
    }
    pauseTransformFeedback() {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.pauseTransformFeedback();
    }
    resumeTransformFeedback() {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.resumeTransformFeedback();
    }
    fenceSync(condition, flags) {
        let sync;
        if (this.passthrough === null) {
            sync = {};
        }
        else {
            sync = this.passthrough.fenceSync(condition, flags);
        }
        return sync;
    }
    deleteSync(sync) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteSync(sync);
    }
    clientWaitSync(sync, flags, timeout) {
        if (this.passthrough === null) {
            return this.CONDITION_SATISFIED;
        }
        else {
            return this.passthrough.clientWaitSync(sync, flags, timeout);
        }
    }
    waitSync(sync, flags, timeout) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.waitSync(sync, flags, timeout);
    }
    getSyncParameter(sync, pname) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.getSyncParameter(sync, pname);
    }
    isSync(sync) {
        if (this.passthrough === null) {
            return sync !== null;
        }
        else {
            return this.passthrough.isSync(sync);
        }
    }
    createVertexArray() {
        let vao;
        if (this.passthrough === null) {
            vao = {};
        }
        else {
            vao = this.passthrough.createVertexArray();
        }
        return vao;
    }
    deleteVertexArray(vertexArray) {
        var _a;
        if (this.state.VERTEX_ARRAY_BINDING === vertexArray) {
            this.state.VERTEX_ARRAY_BINDING = null;
        }
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.deleteVertexArray(vertexArray);
    }
    bindVertexArray(array) {
        var _a;
        this.state.VERTEX_ARRAY_BINDING = array;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.bindVertexArray(array);
    }
    isVertexArray(vertexArray) {
        if (this.passthrough === null) {
            return vertexArray !== null;
        }
        else {
            return this.passthrough.isVertexArray(vertexArray);
        }
    }
    copyBufferSubData(readTarget, writeTarget, readOffset, writeOffset, size) {
        var _a;
        return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.copyBufferSubData(readTarget, writeTarget, readOffset, writeOffset, size);
    }
    getFragDataLocation(program, name) {
        var _a;
        if (this.passthrough === null) {
            return 0;
        }
        else {
            return (_a = this.passthrough) === null || _a === void 0 ? void 0 : _a.getFragDataLocation(program, name);
        }
    }
    getIndexedParameter(target, index) {
        throw new Error('Not implemented by mock.');
    }
    getInternalformatParameter(target, internalformat, pname) {
        if (target !== this.RENDERBUFFER) {
            console.error('Invalid target');
        }
        if (pname !== this.SAMPLES) {
            console.error('Invalid pname');
        }
        if (this.passthrough === null) {
            return new Int32Array([4, 2]);
        }
        else {
            return this.passthrough.getInternalformatParameter(target, internalformat, pname);
        }
    }
}
//# sourceMappingURL=WebGLMock.js.map